export const language_en = {
    "GeneralTab": "General",
    "General": {
        "name": "Name",
        "firstName": "First Name",
        "lastName": "Last Name",
        "clientName": "Client Name",
        "smallName": "Small Name",
        "documentType": "Document Type",
        "date": "Date",
        "time": "Time",
        "installation": "Installation",
        "installations": "Installations",
        "active": "Active",
        "inactive": "Inactive",
        "inActive": "Inactive",
        "preNumber": "Pre Number",
        "number": "Number",
        "client": "Client",
        "supplier": "Supplier",
        "supplierVAT": "Supplier VAT Number",
        "supplierName": "Supplier Name",
        "supplierNameVAT": "Supplier Name/VAT Number",
        "supplierInstallation": "Supplier Installation",
        "vatNumber": "VAT Number",
        "address": "Address",
        "doy": "DOY",
        "city": "City",
        "postalCode": "Postal Code",
        "paymentType": "Payment Method",
        "paymentTypes": "Payment Methods",
        "no": "No",
        "productCode": "Product Code",
        "productName": "Product Name",
        "quantity": "Quantity",
        "measurementUnit": "M.U.",
        "unitPrice": "Unit Price",
        "discount": "Discount",
        "vatPercentage": "VAT %",
        "netValue": "Net Value",
        "vatValue": "Vat Value",
        "isNetValue": "Είναι Καθαρή Αξία",
        "isTax": "Είναι Φόρος",
        "taxes": "Taxes",
        "taxWithholding": "Tax Withholding",
        "totalValue": "Total Value",
        "withholdTaxes": "Withhold Taxes",
        "otherTax": "Other Tax",
        "otherTaxes": "Other Taxes",
        "ruleName": "Rule Name",
        "rules": "Rules",
        "sign": "Sign",
        "fees": "Fees",
        "stampDuty": "Stamp Duty Tax",
        "totals": "Totals",
        "totalQuantity": "Total Quantity",
        "totalBeforeDiscount": "Total Before Discount",
        "totalDiscount": "Total Discount",
        "totalNetValue": "Total Net Value",
        "totalVatValue": "Total VAT Value",
        "totalWithheldAmount": "Total Withheld amount",
        "totalTaxesAmount": "Taxes Totals",
        "totalAmount": "Total Amount",
        "totalCredit": "Total Credit",
        "paymentAmount": "Payment Amount",
        "totalPrice": "Total Price",
        "notes": "Notes",
        "extraData": "Extra Data",
        "wayOfSendingGoods": "Way of sending goods",
        "waysOfSendingGoods": "Ways of sending goods",
        "goodsSendDate": "Goods Send Date",
        "carNumber": "Car Number",
        "carNumbers": "Car Numbers",
        "totalSumFrom": "Total Sum From",
        "totalSumTo": "Total Sum To",
        "sumFrom": "Sum From",
        "sumTo": "Sum To",
        "preNumberFrom": "Pre Number From",
        "preNumberTo": "Pre Number To",
        "numberFrom": "Number From",
        "numberTo": "Number To",
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "reason": "Reason",
        "startDate": "Start Date",
        "endDate": "End Date",
        "phone": "Phone",
        "category": "Category",
        "subCategory": "Subcategory",
        "systemCode": "System Code",
        "manualCode": "Manual Code",
        "vatCategory": "VAT Category",
        "country": "Country",
        "email": "E-Mail",
        "gemhNo": "GEMH No",
        "webpage": "Webpage",
        "contactPoints": "Contact Points",
        "contactName": "Contact Name",
        "mobilePhone": "Mobile Phone",
        "landline": "Landline",
        "otherPhone": "Other Phone",
        "contactNotes": "Contact Notes",
        "myDataStatus": "MyData Status",
        "products": "Products",
        "code": "Code",
        "alternateCode": "Alternative Code",
        "alternateName": "Alternative Name",
        "type": "Type",
        "loading": "Loading...",
        "warning": "Warning!",
        "warningDataLoss": "Your data will be lost, are you sure you want to continue?",
        "warningSupplierInactive": "Are you sure you want to make this supplier inactive?",
        "noOption": "No",
        "yesOption": "Yes",
        "empty": "Empty",
        "serialNumber": "Serial Number",
        "bankName": "Bank Name",
        "iban": "IBAN",
        "amount": "Amount",
        "bankAccountData": "Bank Account Data",
        "posData": "POS Data",
        "chequeData": "Cheque Data",
        "forbidChangeProductsBuys": "Forbid editable prices in new buys",
        "autocompleteProductsInClassification": "Autocomplete products on expenses classifications",
        "autoUpdatePriceSale": "Auto update product price after sale",
        "autoUpdatePriceBuy": "Auto update product price after buy",
        "hide0stockProducts": "Hide out of stock products",
        "paymentOptions": "Payment Options",
        "amka": "Α.Μ.Κ.Α.",
        "createAutomaticSupplierPayment": "Auto-create supplier payment",
        "preselectedPOSBankAccount": "Preselected POS/Bank Account",
        "wildcards": "Wildcards",
        "addWildcard": "Add wildcard",
        "clickWildcard" : "Click on the wildcard to add it in the reason",
        "totalDeductibleNetValue": "Deductible Net Value",
        "totalDeductibleVAT": "Deductible VAT Value",
        "totalNonDeductibleNetValue": "Non Deductible Net Value",
        "totalNonDeductibleVAT": "Non Deductible VAT Value",
        "numbering": "Numbering",
        "applyFilter": "Apply filters",
        "noData": "No data found",
        "filterBy": "Filter by",
        "0vatReason": "0% VAT Reason",
        "customVat": "Custom VAT",
        "subject": "Subject",
        "details": "Details",
        "followUpDate": "Follow up date",
        "followUpDateFrom": "Follow up date from",
        "followUpDateTo": "Follow up date to",
        "done": "Done",
        "activeSupplier": "Active Supplier",
        "autofillData": "Autocomplete details",
        "activity": "Activity",
        "supplierBalance": "Supplier Balance",
        "sum": "Sum",
        "census": "Census",
        "balance": "Balance",
        "BalanceTo": "Balance To",
        "includeInactiveSuppliers": "Include inactive suppliers",
        "includeInactiveClients": "Include inactive clients",
        "includeZeroBalanceSuppliers": "Include suppliers with zero balance",
        "includeZeroBalanceClients": "Include clients with zero balance",
        "includeSettlements": "Include settlements",
        "includeInactive": "Include inactive",
        "accountingAccountType": "Accounting Account Type",
        "templateAccountName": "Template Account Name",
        "supplierFrom": "Supplier from",
        "supplierTo": "Supplier to",
        "instructions": "Instructions",
        "instructionsCodeMask": "Code mask is used to product supplier system code. Character * produces incremental numbering. For example ABC-***, will product ABC-001",
        "categoryName": "Category Name",
        "subcategoryName": "Subcategory Name",
        "codeMask": "Code Mask",
        "dateSelection": "Date Selection",
        "thisMonth": "This Month",
        "lastMonth": "Last Month",
        "thisYear": "This Year",
        "monthSelection": "Monthly Selection",
        "fastFilter": "Fast filtering",
        "amountFrom": "Amount from",
        "amountTo": "Amount to",
        "showInactiveSuppliers": "Show inactive suppliers",
        "credit": "Credit",
        "debit": "Debit",
        "cashRegister": "Cash Register",
        "printer": "Printer",
        "exportPDF": "Export as PDF",
        "exportPNG": "Export as PNG",
        "employee": "Employee",
        "User": "User",
        "logTypes": "Log Type",
        "AccountingYearlyResults": "Accounting Yearly Results",
        "articleCategory": "Article Category",
        "articleSubcategory": "Article Subcategory",
        "articleCreator": "Article Creator",
        "invoiceType": "Invoice Type",
        "correlatedΑrticle": "Correlated Article",
        "clearCorrelatedΑrticle": "Clear Correlated Article",
        "accountingRecordNotes": "Accounting Record Notes",
        "selectInvoiceType": "Select Invoice Type",
        "preferredSalePrice": "Preferred Sale Price",
        "preferredBuyPrice": "Preferred Buy Price",
        "sendToMyData": "Send to MyData",
        "bypassAccounting": "Accounting Bridge Bypass",
        "copyAccountRecord": "Copy Accounting Record",
        "copy": "Copy",
        "filter": "Filter",
        "changeProfileImage": "Change Profile Image",
        "upload": "Upload",
        "imageInstructions": "Images Allowed",
        "pageRefreshAfterSave": "The page will refresh after successful save",
        "passwordChange": "Change Password",
        "currentPassword": "Current Password",
        "currentPasswordPlaceholder": "Insert your current password",
        "newPassword": "New Password",
        "newPasswordPlaceholder": "Insert your new password",
        "passwordConfirm": "Confirm your password",
        "passwordConfirmPlaceholder": "Confirm your new password",
        "changeUserDetails": "Change User Details",
        "lastnamePlaceholder": "Enter last name",
        "emailPlaceholder": "Enter E-Mail",
        "language": "Language",
        "refreshAfterSave": "The page will refresh after successful save",
        "saveChanges": "Save Changes",
        "saveColumns": "Save Columns",
        "bankingConnected": "Connected",
        "firstPage": "First",
        "lastPage": "Last",
        "nextPage": "Next",
        "previousPage": "Previous",
        "includingProductName": "Including Product Name"
    },
    "Confirm": {
        "changeInvoiceType": "Are you sure you want to change the invoice type?"
    },
    "Headers": {
        "SalesGraphicReport": "Sales Graphic Report",
        "BuysNew": "New Buy",
        "BuysEdit": "Edit Buy",
        "BuysView": "View Buy",
        "SupplierPaymentNew": "New Payment",
        "SupplierPaymentEdit": "Edit Payment",
        "BuysMyData": "MyData Buys",
        "BuysBalanceSheet": "Buys Balance Sheet",
        "SupplierBalanceSheet": "Supplier Payments",
        "BuysGraphicReport": "Buys Graphic Report",
        "BuysSettings": "Buys Settings",
        "SupplierNew": "New Supplier",
        "SupplierEdit": "Edit Supplier",
        "SupplierMovementNew": "New Supplier Movement",
        "SupplierMovementEdit": "Edit Supplier Movement",
        "SupplierBalanceReport": "Supplier Balance Report",
        "SupplierMovementReport": "Supplier Movements Report",
        "SupplierSettings": "Supplier Settings"
    },
    "InnerTabs": {
        "buysMyData": "MyData Buys",
        "settings": "Settings",
        "buysEmailSettings": "Buys E-Mail Settings",
        "installations": "Installations",
        "communicationHistory": "Communication History",
        "accounting": "Accounting"
    },
    "Placeholders": {
        "client": "Select client",
        "notes": "Insert notes",
        "selectInstallation": "Select Installation",
        "selectSupplier": "Select supplier",
        "selectFilters": "Please select filters and press the 'Apply Filters' button",
        "selectProductCode": "Select Product Code",
        "selectProductName": "Select Product Name",
        "selectClient": "Select Client",
        "selectEmployee": "Select Employee",
        "reason": "Insert reason",
        "correlatedΑrticle": "Insert a correlated article",
        "accountingRecordNotes": "Add accounting record notes",
        "preferredSalePrice": "Sale price",
        "preferredBuyPrice": "Buy price"
    },
    "Required": {
        "selectSupplierFirst": "Please select supplier",
        "selectDocumentFirst": "Please select document type",
        "selectCategoryFirst": "Please select category",
        "productList": "Product table cannot be empty",
        "installation": "Installation is mandatory.",
        "preNumber": "Pre Number is mandatory.",
        "number": "Number is mandatory",
        "supplier": "Supplier is mandatory.",
        "emailOrPhone": "Please fill e-mail or phone",
        "name": "Name is mandatory.",
        "vatCategory": "VAT Category is mandatory.",
        "0vatReason": "0% VAT Reason is mandatory.",
        "customVat": "Custom VAT is mandatory.",
        "vatNumber": "VAT Number is mandatory.",
        "doy": "DOY is mandatory",
        "activity": "Activity is mandatory.",
        "country": "Country is mandatory.",
        "address": "Address is mandatory.",
        "city": "City is mandatory.",
        "postalCode": "Postal Code is mandatory.",
        "invalidEmail": "E-Mail is invalid."
    },
    "printResults": {
        "name": "Print Results",
        "printer": "Printer",
        "pdf": "Save as PDF",
        "excel": "Save as Excel"
    },
    "Products": "Products",
    "Sales": "Sales",
    "Clients": "Clients",
    "Suppliers": "Suppliers",
    "Buys": "Buys",
    "SelectPlaceholder": "Select...",
    "Cash Registers - POS - Bank Accounts": "Cash Registers - POS - Bank Accounts",
    "Prescription": "Prescription",
    "Null": "Null/Blank",
    "Accounting": "Accounting",
    "Payroll": "Payroll",
    "FixedAssets": "Fixed Assets",
    "Settings": "Settings",
    "LoaderText": {
        "loading": "Loading",
        "cancel": "Cancel",
        "loaderDesc5": "It looks like you requested over 5000 documents. Please wait as the pumping process may take up to 5 minutes",
        "loaderDesc15": "It looks like you requested over 5000 documents. Please wait as the pumping process may take up to 15 minutes"
    },
    "RestartApplyFiltersModal": {
        "desc": "Warning: Another user with name: ",
        "desc2": " is already trying to pull data. Do you want to continue and cancel the user's attempt?"
    },
    "TabsText": {
        "start": "Start",
        "products-new": "products new",
        "products-search": "products search",
        "edit-product": "edit product",
        "product-movements-new": "product movements new",
        "product-movements-search": "product movements new",
        "edit-product-movements": "product movements new",
        "product-pricelist-new": "New price list",
        "pricelist-search": "Search price list",
        "edit-price-list": "Edit price list",
        "product-balancesheet-reports": "Balance Sheet",
        "product-movments-reports": "Product Movements",
        "products-settings-product-categories": "Settings",
        "sales-new": "Sales New",
        "sales-search": "Sales Search",
        "primer-ai-url": "Primer AI",
        "view-sales": "View Sales",
        "sales-quotations-new": "Quotations New",
        "sales-quotations-search": "Quotations Search",
        "sales-quotations-view": "View Quotations",
        "sales-quotations-edit": "Edit Quotation",
        "search-quick-retail-sales": "Quick Retail Sales Search",
        "new-client-payments": "Client Payments New",
        "search-client-payments": "Client Payments Search",
        "edit-client-payments": "Edit Client Payments New",
        "new-automatic-sales": "Automatic Sales New",
        "search-automatic-sales": "Automatic Sales Search",
        "edit-automatic-sales": "Edit Automatic Sales",
        "mydata-report": "mydata report",
        "sales-monthly-turnover": "Sales Monthly Turnover",
        "buys-monthly-turnover": "Buys Monthly Turnover",
        "sales-balance-sheet": "Sales Report",
        "sales-graphic-report": "graphic report",
        "client-payments-report": "Client Payments Report",
        "sales-general-settings": "Sales Settings",
        "quick-retail-sales-settings": "Quick Retail Sales Settings",
        "new-client": "new client",
        "search-client": "search client",
        "edit-client": "edit client",
        "new-client-movements": "new client movements",
        "search-client-movements": "search client movements",
        "edit-client-movements": "edit client movements",
        "client-balance": "client balance",
        "clients-movements": "clients movements",
        "report-client-isozygio": "clients isozygio",
        "clients-settings": "clients settings",
        "cash-registers-new": "cash registers new",
        "cash-registers-search": "cash registers search",
        "new-pos": "new pos",
        "search-pos": "search pos",
        "edit-pos": "edit pos",
        "new-bank-account": "new-bank-account",
        "search-bank-account": "search-bank-account",
        "edit-bank-account": "edit-bank-account",
        "cash-reports": "cash reports",
        "general-settings": "general settings",
        "primer-my-data": "primer my data",
        "primer-my-data-data": "Settings Primer Data",
        "basic-types-new": "basic types new",
        "basic-types-search": "basic types search",
        "edit-basic-types": "basic types",
        "advanced-types-new": "Advanced Type New",
        "advanced-types-search": "Advanced Type Search",
        "edit-advanced-types": "Edit Advanced Type",
        "company-settings": "Company Settings",
        "system-tasks": "System Tasks",
        "email-smtp": "Email Smtp",
        "subscriptions": "Subscriptions",
        "settings-import": "Settings Import",
        "settings-export": "Settings Export",
        "settings-backup": "Settings Backup",
        "settings-restore": "Settings Restore",
        "employee-new": "New Employee",
        "employee-edit": "Edit Employee",
        "employee-search": "Search Employee",
        "accounting-account-new": "New Accounting Account",
        "accounting-account-edit": "Edit Accounting Account",
        "accounting-account-search": "Search Accounting Accounts",
        "accounting-record-new": "New Accounting Record",
        "accounting-record-edit": "Edit Accounting Record",
        "accounting-record-search": "Search Accounting Records",
        "accounting-record-settings": "Accounting Record Settings",
        "accounting-settings": "Accounting Settings",
        "reports-client-subscriptions": "Client Subscriptions Reports",
        "accounting-report-isozygio": "Isozygio",
        "accounting-report-accounts": "Accounts Report",
        "accounting-report-calendar": "Accounts Calendar",
        "accounting-report-general-calendar": "General Calendar",
        "accounting-ie-book": "Income/Expense Book",
        "buys-new": "New Buy",
        "buys-search": "Buys Search",
        "edit-buys": "Edit Buy",
        "buys-mydata-report": "MyData Buys",
        "buys-balance-sheet": "Buys Report",
        "accounting-bridge-settings": "Accounting Bridge",
        "reports-primer-payments": "Subscription Payments",
        "cdr-viewer": "CDR Viewer",
        "accounting-year-report": "Year Report",
        "buys-general-settings": "Buys Settings",
        "buys-graphic-report": "Buys Graphic Report",
        "supplier-payments-report": "Supplier Payments Report",
        "new-supplier-payments": "New Supplier Payment",
        "edit-supplier-payments": "Edit Supplier Payment",
        "search-supplier-payments": "Search Supplier Payments",
        "report-supplier-isozygio": "suppliers isozygio",
        "cash-settings-accounting": "Acc. Cash Settings",
        "primer-client-payments": "Primer Client Payments",
        "emron-client-payments": "Emron Client Payments",
        "user-settings": "User Settings",
        "manage-companies": "Manage Companies",
        "reports-emron-settlements": "Settlements Report",
        "reports-primer-pos": "Primer POS Report",
        "primer-post-new-list": "New Primer POS List",
        "primer-post-search-list": "Search Primer POS List",
        "edit-cash-registers": "Edit Cash Register",
        "payroll-settings": "Payroll Settings",
        "working-program": "Working Program",
        "working-program-employee": "Employee Working Program",
        "new-work-movement": "New Work Movement",
        "edit-work-movement": "Edit Work Movement",
        "search-work-movements": "Search Work Movements",
        "new-dcl": "Digital Customer Base",
        "edit-dcl": "Edit Digital Customer Base Movement",
        "search-dcl": "Search Digital Customer Base Movements",
        "payroll-qr-scanner": "QR Scanner",
        "master-log-search": "System history",
        "reports-companies-ai-usage": "AI Usage Stats",
        "ergani-submissions-report": "Ergani Submissions",
        "employee-view": "Employee Card",
        "new-work-permit": "New Work Permit",
        "edit-work-permit": "Edit Work Permit",
        "search-work-permits": "Search Work Permits",
        "components": "Components",
        "new-quick-retail-sales": "New Sale (e-Tameiaki)",
        "accounting-transfer": "Account Transfer",
        "payroll-hour-report": "Payroll Hour Report",
        "Cloud": "Primer Connect",
        "reports-primer-payments-admin": "Primer Payments Report",
        "accounting-closure": "Κλείσιμο Λογαριασμών",
        "accounting-operating-statement": "Operating Statement",
        "prescription-settings": "Prescription Settings",
        "visit-new": "New Visit",
        "visit-active": "Active Visit",
        "search-visits": "Search Visits",
        "search-prescriptions": "Search Prescriptions",
        "search-referrals": "Search Referrals",
        "search-icd10s": "Search IC10s",
        "search-drugs": "Search Medicines",
        "search-exams": "Search Examinations",
        "visit-edit": "View visit",
        "prescription-edit": "View prescription",
        "referral-edit": "View Referral",
        "prescription-home": "Prescription",
        "patient-history": "Patient History",
        "reports-drugs": "Medicine Report",
        "reports-prescriptions": "Prescriptions Report",
        "classifications-report": "Classifications Report",
        "accounting-report-vat-information": "Φ2 VAT Report",
        "accounting-issue-vat-information": "Φ2 VAT Issue",
        "accounting-issue-f4-vat-information": "Φ4 VAT Issue",
        "accounting-issue-f5-vat-information": "Φ5 VAT Issue",
        "accounting-submitted-declarations": "Submitted Declarations",
        "accounting-submitted-f4-declarations": "Submitted Φ4 Declarations",
        "accounting-submitted-f5-declarations": "Submitted Φ5 Declarations",
        "accounting-debts-search": "search Debts",
        "prescription-monthly-invoicing": "Monthly Invoicing",
        "accounting-banking-transactions": "Banking Transactions",
        "accounting-banking-agreements": "Banking Agreements",
        "accounting-banking-agreements-admin": "Banking Agreements",
        "work-permit-report": "Work Permit Report",
        "fixedassets-settings": "Fixed Assets Settings",
        "new-fixed-asset": "New Fixed Asset",
        "edit-fixed-asset": "Edit Fixed Asset",
        "new-fixed-asset-movement": "New Fixed Asset Movement",
        "edit-fixed-asset-movement": "Edit Asset Movement",
        "new-fixed-asset-record": "New Asset Record",
        "edit-fixed-asset-record": "Edit Asset Record",
        "search-fixed-assets": "Search Fixed Assets",
        "search-fixed-asset-movements": "Search Fixed Asset Movements",
        "search-fixed-asset-records": "Search Asset Records",
        "report-fixed-asset-movements": "Asset Movements",
        "report-fixed-asset-book": "Asset Book",
        "report-sold-fixed-assets": "Sold Assets",
        "report-client-provider-contracts": "Client Contracts",
        "ai-settings": "AI Settings",
        "ai-module": "AI",
        "new-transfer": "New Transfer",
        "search-transfers": "Search Transfers",
        "generated-group-qrs": "Group QRs",
        "new-cheque": "New Cheque",
        "edit-cheque": "Edit Cheque",
        "search-cheques": "Search Cheques",
        "cheque-report": "Cheque Report",
        "new-loan": "New Loan",
        "edit-loan": "Edit Loan",
        "search-loans": "Search Loans",
        "loan-report": "Loans Report",
        "banking-settings": "Banking Settings",
        "accounting-ai-banking-transactions": "Banking Trans. AI",
        "view-submitted-vat-declaration": "Submitted VAT Declaration",
        "cards-new": "New Card",
        "cards-edit": "Edit Card",
        "cards-search": "Search Cards"
    },
    "SearchTableIndex": {
        "filterBy": "Filter By",
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "applyFilter": "Apply filter",
        "sendFilteredToMyData": "Send Filtered to MyData",
        "warning": "Warning!",
        "message": "Warning: All the documents that match the filters will be send to MyData, do you want to continue?",
        "no": "No",
        "yes": "Yes",
        "sendToMyDataReport": "Send To MyData Report",
        "message2": "Below are shown the results for the sending of the selected Documents to MyData:",
        "filters": "Filters"
    },
    "SaveAsTemplateIndex": {
        "saveAsTemplate": "Save as Template",
        "nameOfNewTemplate": "Name of New Template",
        "placeholder": "Template Name",
        "message": "Allow users with no rights to write extra data",
        "useTemplateForAutomaticSales": "Use Template for Automatic Sales",
        "cancel": "Cancel",
        "save": "Save"
    },
    "DataPanelIndex": {
        "template": {
            "template": "Template",
            "placeholder": "Select Template"
        },
        "sendEmailToExistingClientContactPoints": "Send Email to Existing Client Contact Points:",
        "placeholder": "Select one or more contact points",
        "pleaseSelectAtLeastOneEmailAddress": "Please select at least one email address.",
        "sendEmailToCustomEmailAddresses": {
            "sendEmailToCustomEmailAddresses": "Send Email to Custom Email Addresses:",
            "placeholder": "Please write multiple emails comma separated",
            "warning": "Please input a correct email address."
        },
        "create": "Create",
        "printLayout": "Print Layout",
        "print": "Print",
        "covertDocument": "Convert Document",
        "convertQuotation": "Convert Quotation",
        "issueCreditDocument": "Issue Credit Document",
        "cancelInvoiceFromMyData": "Cancel Invoice from MyData",
        "clear": "Clear",
        "saveAndRepeat": "Save and Repeat",
        "delete": "Delete",
        "save": "Save",
        "templateChange": "Template Change Warning!!",
        "templateWarning": "All data in the form will be replaced, are you sure?",
        "no": "No",
        "yes": "Yes",
        "deleteConfirmation": "Delete Confirmation",
        "activateConfirmation": "Activate Confirmation",
        "deleteMessage": "Are you sure you want to delete that item?",
        "activateMessage": "Are you sure you want to save an active price list? Another price list is already active and will be deactivated by saving the new one.",
        "cancel": "Cancel",
        "convertDocumentConfirmation": "Convert Document Confirmation",
        "convertQuotationConfirmation": "Convert Quotation Confirmation",
        "convertDocumentMessage": "You 're about to Convert the selected Document. Proceed?",
        "convertQuotationMessage": "You 're about to Convert the selected Quotation.",
        "convertQuotationQuestion": "Proceed?",
        "issueCreditDocumentConfirmation": "Issue Credit Document Confirmation",
        "issueCreditDocumentMessage": "You 're about to issue a new credit document for this document. Proceed?",
        "cancelMyDataDocumentConfirmation": "Cancel MyData Document Confirmation",
        "cancelMyDataDocumentMessage": "You 're about to cancel this document from MyData. Proceed?",
        "sendEmailOnSave": "Send email on save",
        "convert": "Convert"
    },
    "DatePanelIndex": {
        "template": "Template",
        "saveAndRepeat": "Save and Repeat",
        "delete": "Delete"
    },
    "EditableTableIndex": {
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "deleteSelected": "Delete Selected",
        "warning": "Warning!",
        "warningMessage1": "Warning: You have selected",
        "warningMessage2": "documents to be sent to MyData, do you want to continue?",
        "no": "No",
        "yes": "Yes",
        "sendToMyDataReport": "Send To MyData Report",
        "sendToMyDataReportMessage": "Below are shown the results for the sending of the selected Documents to MyData:",
        "sendSelectedDocumentsToMyData": "Send Selected Documents to MyData"
    },
    "CompanyTable": {
        "company": "Company",
        "number": "Number",
        "selectCompanyAndYear": "Select Company and Year",
        "selectYear": "Select Year",
        "close": "Close",
        "select": "Select",
        "placeholder": "Search by name or VAT number..."
    },
    "ProductsSideBar": {
        "Products": {
            "title": "Products",
            "new": "New",
            "search": "Search"
        },
        "Movements": {
            "title": "Products Movements",
            "new": "New",
            "search": "Search"
        },
        "List": {
            "title": "Price List",
            "new": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "balanceSheet": "Balance Sheet",
            "productMovements": "Product Movements"
        },
        "Settings": {
            "title": "Settings",
            "productCategories": "Product Categories"
        },
        "Components": {
            "title": "Components",
            "primerComponents": "Primer Components"
        }
    },
    "SalesSideBar": {
        "Sales": {
            "title": "Sales",
            "new": "New",
            "search": "Search",
            "primer-ai-url": "Primer AI"
        },
        "QuickRetailSales": {
            "title": "Quick Retail Sales",
            "new": "New",
            "search": "Search"
        },
        "ClientPayments": {
            "title": "Client Payments",
            "new": "New",
            "search": "Search"
        },
        "AutomaticSales": {
            "title": "Automatic Sales",
            "new": "New",
            "search": "Search"
        },
        "MyData": {
            "title": "MyData",
            "report": "MyData Report"
        },
        "Reports": {
            "title": "Reports",
            "monthlyTurnover": "Monthly Turnover",
            "salesBalanceSheet": "Sales Balance Sheet",
            "salesGraphicReport": "Sales Graphic Report",
            "clientPaymentReport": "Client Payment Report"
        },
        "Settings": {
            "title": "Settings",
            "SalesGeneralSettings": "Sales General Settings",
            "QuickRetailSettings": "Quick Retail Sales"
        }
    },
    "BuysSideBar": {
        "Buys": {
            "title": "Buys",
            "new": "New",
            "search": "Search"
        },
        "MyData": {
            "title": "MyData",
            "report": "MyData Report"
        },
        "SupplierPayments": {
            "title": "Payments",
            "new": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "monthlyTurnover": "Monthly Turnover",
            "buysBalanceSheet": "Buys Balance Sheet",
            "buysGraphicReport": "Buys Graphic Report",
            "supplierPaymentsReport": "Buys Graphic Report"
        },
        "Settings": {
            "title": "Settings",
            "buysGeneralSettings": "Buys General Settings"
        }
    },
    "ClientSideBar": {
        "General": {
            "title": "Clients",
            "general": "New",
            "search": "Search"
        },
        "Movements": {
            "title": "Client Movements",
            "general": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "clientBalance": "Client Balance",
            "clientsMovements": "Clients Movements"
        },
        "Settings": {
            "title": "Settings",
            "clientSettings": "Client Settings"
        }
    },
    "Cash": {
        "CashRegisters": {
            "title": "Cash Registers",
            "new": "New",
            "search": "Search"
        },
        "POS": {
            "title": "POS",
            "new": "New",
            "search": "Search"
        },
        "bankAccounts": {
            "title": "Bank Accounts",
            "new": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "cash": "Cash"
        },
        "Settings": {
            "title": "Settings",
            "general": "General"
        }
    },
    "SupplierSideBar": {
        "General": {
            "title": "Suppliers",
            "general": "New",
            "search": "Search"
        },
        "Movements": {
            "title": "Supplier Movements",
            "general": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "supplierBalance": "Supplier Balance",
            "supplierMovements": "Supplier Movements"
        },
        "Settings": {
            "title": "Settings",
            "supplierSettings": "Suppliers Settings"
        }
    },
    "AccountingSideBar": {
        "Employee": {
            "title": "Employees",
            "new": "New",
            "search": "Search"
        },
        "AccountingAccounts": {
            "title": "Accounting Accounts",
            "new": "New",
            "search": "Search"
        },
        "AccountingRecords": {
            "title": "Accounting Records",
            "new": "New",
            "search": "Search"
        },
        "Reports": {
            "title": "Reports",
            "balanceSheet": "Balance Sheet",
            "accountActivities": "Account Activities",
            "accountRecords": "Account Records"
        },
        "Settings": {
            "title": "Settings",
            "accounting": "Accounting",
            "sendMyDataData": "Send MyData Data",
            "recordTemplates": "Record Templates",
            "accountTransfer": "Account Transfer"
        },
        "Forms": {
            "title": "Forms"
        },
        "Debts": {
            "title": "Debts",
            "search": "Search"
        }
    },
    "SettingsSideBar": {
        "PrimerMyData": {
            "title": "Primer MyData",
            "data": "Data"
        },
        "DocumentType": {
            "title": "Document Type",
            "basicTypesNew": "Basic Types New",
            "basicTypesSearch": "Basic Types Search",
            "advancedTypesNew": "Advanced Types New",
            "advancedTypesSearch": "Advanced Types Search"
        },
        "GeneralSettings": {
            "title": "General Settings",
            "companySettings": "Company Settings",
            "systemTasks": "System Tasks",
            "emailSTMP": "Email Smtp",
            "subscriptions": "Subscriptions",
            "logHistory": "System history",
            "aiUsageCompaniesReport": "AI Usage Stats"
        },
        "ImportExport": {
            "title": "Import-Export",
            "import": "Import",
            "export": "Export"
        },
        "BackupRestore": {
            "title": "Backup-Restore",
            "backup": "Backup",
            "restore": "Restore"
        }
    },
    "NavBar": {
        "start": "Start",
        "products": "Products",
        "sales": "Sales",
        "buys": "Buys",
        "clients": "Clients",
        "suppliers": "Suppliers",
        "cash": "Cash",
        "accounting": "Accounting",
        "payroll": "Payroll",
        "prescription": "Prescriptioning",
        "fixedassets": "Fixed Assets",
        "settings": "Settings",
        "signOut": "Sign out"
    },
    "Headings": {
        "newProduct": "New Product",
        "editProduct": "Edit Product",
        "newProductMovements": "New Product Movements",
        "editProductMovements": "Edit Product Movements",
        "newPriceList": "New Price List",
        "editPriceList": "Edit Price List",
        "reportsBalanceSheet": "Balance Sheet",
        "productMovements": "Product Movements",
        "productCategoriesSettings": "Product Categories Settings",
        "primerMyData": "Primer MyData",
        "settingsPrimerData": "Settings Primer Data",
        "newBasicTypes": "New Basic Types",
        "editBasicTypes": "Edit Basic Types",
        "basicTypesSearch": "Basic Types Search",
        "newAdvancedType": "New Advanced Type",
        "editAdvancedType": "Edit Advanced Type",
        "advancedTypesSearch": "Advanced Types Search",
        "companySettings": "Company Settings",
        "systemTasks": "System Tasks",
        "newClient": "New Client",
        "searchClient": "Search Client",
        "editClient": "Edit Client",
        "newClientMovements": "New Client Movements",
        "editClientMovements": "Edit Client Movements",
        "clientMovementsSearch": "Client Movements Search",
        "clientBalance": "Client Balance",
        "clientMovements": "Client Movements",
        "clientsSettings": "Clients Settings",
        "newSales": "New Sales",
        "salesSearch": "Sales Search",
        "viewSales": "View Sales",
        "editSales": "Edit Sales",
        "newQuickRetailSales": "Quick Retail Sales New",
        "QuickRetailSalesSearch": "Quick Retail Sales Search",
        "editQuickRetailSales": "Edit Quick Retail Sales",
        "clientPaymentsNew": "Client Payments New",
        "clientPaymentsSearch": "Client Payments Search",
        "editClientPayments": "Edit Client Payments New",
        "automaticSalesNew": "Automatic Sales New",
        "editAutomaticSales": "Edit Automatic Sales",
        "automaticSalesSearch": "Automatic Sales Search",
        "myDataDataReport" :"MyData Report",
        "salesBalanceSheet" :"Balance Sheet",
        "salesGraphicReport" :"Graphic Report",
        "salesClientPaymentReport" :"Client Payment Report",
        "salesGeneralSettings": "Sales Settings",
        "quickRetailSalesSettings": "Quick Retail Sales Settings",
        "newCashRegisters": "New Cash Registers",
        "cashRegistersSearch": "New Cash Registers",
        "editCashRegisters": "Edit Cash Registers",
        "newPOS": "New POS",
        "searchPOS": "Search POS",
        "editPOS": "Edit POS",
        "newEmployee": "New Employee",
        "searchEmployee": "Search Employee",
        "editEmployee": "Edit Employee",
        "newAccountingAccount": "New Accounting Account",
        "searchAccountingAccount": "Search Accounting Account",
        "editAccountingAccount": "Edit Accounting Account",
        "newAccountingRecord": "New Accounting Record",
        "searchAccountingRecord": "Search Accounting Record",
        "editAccountingRecord": "Edit Accounting Record",
        "newBankAccount": "New Bank Account",
        "editBankAccount": "Edit Bank Account",
        "bankSearch": "Bank Search"
    },
    "ProductsNewGeneralTabs": {
        "general": "General",
        "otherTaxes": "Other Taxes",
        "accounting": "Accounting",
        "tags": "Tags",
        "variants": "Variants"
    },
    "ProductsNewGeneralEditTabs": {
        "general": "General",
        "otherTaxes": "Other Taxes",
        "accounting": "Accounting",
        "tags": "Tags"
    },
    "ProductVariants": {
        "delete": "Delete Variant",
        "deleteMultiple": "Delete Variants",
        "confirmDelete": "Variant is about to be deleted. Proceed?",
        "confirmDeleteMultiple": "Selected variants are about to be deleted. Proceed?",
        "autoCreate": "Auto Create",
        "confirmAutoCreate": "Variants will be generated automatically based on product properties. Existing ones will not be overwritten.",
        "productProperties": "Product Properties"
    },
    "ProductsMovementsNewTabs": {
        "general": "General"
    },
    "ProductsNewGeneral": {
        "table": {
            "name": "Name",
            "rowType": "Row Type",
            "invoiceType": "Invoice Type",
            "category": "Category",
            "type": "Type",
            "vatExpenseType": "VAT Expense Type"
        },
        "message": "Please select category first..",
        "invetoryBalance": "Product Inventory Balance:",
        "productActive": "Product Active:",
        "files": "Files",
        "errorMessage": "My Data should have at least one row.",
        "productCategory": {
            "productCategory": "Product Category",
            "required": "Product Category is required."
        },
        "productName": {
            "productName": "Product Name",
            "placeholder": "Product Name",
            "required": "Product Name is required."
        },
        "alternativeName": {
            "alternativeName": "Alternative Name",
            "placeholder": "Alternative Name"
        },
        "productCode": {
            "productCode": "Product Code",
            "placeholder": "Product Code"
        },
        "alternativeCode": {
            "alternativeCode": "Alternative Code",
            "placeholder": "Alternative Code"
        },
        "vat": {
            "vat": "VAT %",
            "required": "VAT is required."
        },
        "customVat": {
            "customVat": "Custom VAT %",
            "placeholder": "Custom VAT",
            "required": "Custom Vat is required."
        },
        "0VatReason": {
            "0VatReason": "0% VAT Reason",
            "required": "VAT Reason is required.."
        },
        "measurementUnit": {
            "measurementUnit": "Measurement Unit",
            "required": "Measurement Unit is required."
        },
        "preferredPrice": {
            "preferredPrice": "Preferred Price",
            "placeholder": "Preferred Price"
        },
        "vatIncluded": "VAT Included",
        "productNotes": "Product Notes",
        "addProductNotes": "Add Product Notes",
        "warning": "Category Change Warning!!",
        "warningMessage": "Data entered are going to change, are you sure?",
        "no": "No",
        "yes": "Yes",
        "packagingDetails": "Packaging Details",
        "packagingQuantity":  "Packaging Quantity",
        "packagingType": "Packaging Type"
    },
    "ProductsNewGeneralEdit": {
        "table": {
            "name": "Name",
            "invoiceType": "Invoice Type",
            "category": "Category",
            "type": "Type",
            "vatExpenseType": "VAT Expense Type"
        },
        "table2": {
            "supplierCode": "Supplier Code",
            "supplierName": "Supplier Name",
            "vat": "Vat"
        },
        "table3": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "table4": {
            "type": "Type",
            "address": "Address",
            "inventory": "Inventory"
        },
        "save": "Save",
        "delete": "Delete",
        "message": "Please select category first..",
        "invetoryBalance": "Product Inventory Balance:",
        "productActive": "Product Active:",
        "files": "Files",
        "errorMessage": "My Data should have at least one row.",
        "productCategory": {
            "productCategory": "Product Category",
            "required": "Product Category is required."
        },
        "productName": {
            "productName": "Product Name",
            "placeholder": "Product Name",
            "required": "Product Name is required."
        },
        "alternativeName": {
            "alternativeName": "Alternative Name",
            "placeholder": "Alternative Name"
        },
        "productCode": {
            "productCode": "Product Code",
            "placeholder": "Product Code"
        },
        "alternativeCode": {
            "alternativeCode": "Alternative Code",
            "placeholder": "Alternative Code"
        },
        "vat": {
            "vat": "VAT %",
            "required": "VAT is required."
        },
        "customVat": {
            "customVat": "Custom VAT %",
            "placeholder": "Custom VAT",
            "required": "Custom Vat is required."
        },
        "0VatReason": {
            "0VatReason": "0% VAT Reason",
            "required": "VAT Reason is required.."
        },
        "measurementUnit": {
            "measurementUnit": "Measurement Unit",
            "required": "Measurement Unit is required."
        },
        "preferredPrice": {
            "preferredPrice": "Preferred Price",
            "placeholder": "Preferred Price"
        },
        "vatIncluded": "VAT Included",
        "productNotes": "Product Notes",
        "addProductNotes": "Add Product Notes"
    },
    "ProductsNewOtherTaxes": {
        "otherTaxes": "Other Taxes",
        "withholdTaxes": "Withhold Taxes",
        "stamp": "Stamp",
        "fees": "Fees",
        "message": "Select Product Category To Activate Fields",
        "message2": "*Here you can select the other taxes of the product. If you select a tax that has a euro value (for example 5 euros), the total price of the product will be calculated as the total tax. In that case you can use the product ONLY for tax amount purposes.",
        "save": "Save"
    },
    "ProductsNewAccounting": {
        "accounting": "Accounting",
        "message": "Coming Soon..."
    },
    "ProductsNewTags": {
        "productCodes": "Product Codes",
        "productTag": "Product Tag",
        "addTag": "Add Tag",
        "table": {
            "supplier": "Supplier",
            "productName": "Product Name",
            "productCode": "Product Code",
            "selectSupplierName": "Select Supplier Name"
        },
        "table2": {
            "supplierCode": "Supplier Code",
            "supplierName": "Supplier Name",
            "vat": "Vat"
        },
        "table3": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "save": "Save"
    },
    "ProductsSearchGeneral": {
        "table": {
            "productCode": "Product Code",
            "productName": "Product Name",
            "productCategory": "Product Category / Subcategory",
            "productTags": "Product Tags",
            "alternativeName": "Alternative Name",
            "alternativeCode": "Alternative Code",
            "productInventoryBalance": "Product Inventory Balance",
            "productActive": "Product Active",
            "productPrice": "Product Sale Price",
            "productBuyPrice": "Product Buy Price",
            "supplierProductName": "Supplier Product Name",
            "supplierProductCode": "Supplier Product Code"
        },
        "tableFilter": {
            "productNameFrom": "Product Name From",
            "productNameTo": "Product Name To",
            "productCodeFrom": "Product Code From",
            "productCodeTo": "Product Code To",
            "productCategoryFrom": "Product Category From",
            "productCategoryTo": "Product Category To",
            "supplierProductNameFrom": "Supplier Product Name From",
            "supplierProductNameTo": "Supplier Product Name To",
            "supplierProductCodeFrom": "Supplier Product Code From",
            "supplierProductCodeTo": "Supplier Product Code To",
            "showInActiveProducts": "Show InActive Products"
        }
    },
    "ProductsMovementsNew": {
        "smallTable": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "table": {
            "productCode": "Product Code",
            "productCodePlaceholder": "Select Product Code",
            "productName": "Product Name",
            "productNamePlaceholder": "Select Product Name",
            "mu": "M.U.",
            "quantity": "Quantity",
            "required": "Table should have at least one row"
        },
        "message": "Please select Document Type first..",
        "files": "Files",
        "documentTypes": "Document Types",
        "installation": "Installation",
        "preNumber": "Pre Number",
        "innerMovement": "Move to another installation",
        "innerMovementMessage": "Leave empty if it is not an internal movement.",
        "number": {
            "number": "Number",
            "placeholder": "Document Number"
        },
        "date": "Date",
        "reason": {
            "reason": "Reason",
            "placeholder": "Enter Reason"
        },
        "sum": "Sum",
        "movementsNotes": "Movements Notes",
        "addMovementsNotes": "Add Movements Notes"
    },
    "ProductsMovementsNewEdit": {
        "smallTable": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "table": {
            "productCode": "Product Code",
            "productCodePlaceholder": "Select Product Code",
            "productName": "Product Name",
            "productNamePlaceholder": "Select Product Name",
            "mu": "M.U.",
            "quantity": "Quantity",
            "required": "Table should have at least one row"
        },
        "message": "Please select Document Type first..",
        "files": "Files",
        "documentTypes": "Document Types",
        "installation": "Installation",
        "preNumber": "Pre Number",
        "number": {
            "number": "Number",
            "placeholder": "Document Number"
        },
        "date": "Date",
        "reason": {
            "reason": "Reason",
            "placeholder": "Enter Reason"
        },
        "sum": "Sum",
        "movementsNotes": "Movements Notes",
        "addMovementsNotes": "Add Movements Notes"
    },
    "ProductsMovementsSearch": {
        "table": {
            "date": "Date",
            "reason": "Reason",
            "totalAmount": "Total Amount",
            "totalQuantity": "Total Quantity",
            "totalNetValue": "Total Net Value",
            "totalVatValue": "Total Vat Value",
            "products": "Products",
            "number": "Number",
            "documentType": "Document Type"
        }
    },
    "ProductsListNewTabs": {
        "general": "General"
    },
    "ProductsListNew": {
        "smallTable": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "table": {
            "productCode": "Product Code",
            "productName": "Product Name",
            "client": "Client",
            "price": "Price",
            "vat": "V.A.T.",
            "discount": "Discount",
            "placeholderCode": "Select Product Code",
            "placeholderName": "Select Product Name"
        },
        "pricelistActive": "Pricelist Active",
        "name": "Name",
        "namePlaceholder": "Enter price list name",
        "required": "Name is a required field.",
        "files": "Files",
        "priceListNotes": "Price List Notes",
        "addPriceListNotes": "Add Price List Notes",
        "warning": "Table should not be empty."
    },
    "ProductsListNewEdit": {
        "smallTable": {
            "code": "Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "table": {
            "productCode": "Product Code",
            "productName": "Product Name",
            "client": "Client",
            "price": "Price",
            "vat": "V.A.T.",
            "discounrt": "Discount"
        },
        "pricelistActive": "Pricelist Active",
        "name": "Name",
        "namePlaceholder": "Enter price list name",
        "required": "Name is a required field.",
        "files": "Files",
        "priceListNotes": "Price List Notes",
        "addPriceListNotes": "Add Price List Notes",
        "warning": "Table should not be empty."
    },
    "ProductsListSearch": {
        "smallTable": {
            "priceListName": "Price List Name",
            "showActivePriceList": "Show Active Pricelist"

        },
        "table": {
            "productPriceList": "Product Price List",
            "active": "Active"
        }
    },
    "ReportsBalanceSheetTabs": {
        "general": "General"
    },
    "ReportsBalanceSheet": {
        "smallTable": {
            "productCode": "Product Code",
            "productName": "Product Name"
        },
        "table": {
            "inventory": "Inventory",
            "productCode": "Product Code",
            "productName": "Product Name",
            "inventoryBalance": "Inventory Balance",
            "inactiveInventoryBalance": "Include Inactive Products"
        },
        "productName": "Product Name",
        "filterMessage": "Please select filters first and press \"Apply filters\"\n",
        "includeInactiveProducts": "Include Inactive Products",
        "includeZeroBalanceProducts": "Include products with zero balance",
        "applyFilter": "Apply Filter",
        "productsBalance": "Products Balance",
        "page": "Page:",
        "of": "of",
        "first": "<< First",
        "previous": "< Previous",
        "next": "Next >>",
        "last": "Last >>",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        }
    },
    "ReportsProductMovementsTabs": {
        "general": "General"
    },
    "ReportsProductMovements": {
        "table": {
            "filterBy": "Filter By",
            "dateFrom": "Date From",
            "productName": "Product Name",
            "productFrom": {
                "productFrom": "Product From",
                "placeholder": "Select Product"
            },
            "dateTo": "Date To",
            "productTo": {
                "productTo": "Product To",
                "placeholder": "Select Product"
            },
            "includeProductsWithZeroBalance": "Include products with zero balance",
            "includeInactiveProducts": "Include Inactive Products",
            "includeMovementsNotAffectingInventory": "Include Movements Not Affecting Inventory"
        },
        "table2": {
            "date": "Date",
            "invoiceType": "Invoice Type",
            "number": "Number",
            "movementType": "Movement Type",
            "inventoryAmount": "Inventory Amount",
            "balance": "Balance"
        },
        "filterMessage": "Please select filters first and press \"Apply filters\"\n",
        "applyFilter": "Apply Filter",
        "productTab": "Product Tab",
        "productCode": "Product Code:",
        "productName": "Product Name:",
        "page": "Page:",
        "of": "of",
        "first": "<< First",
        "previous": "< Previous",
        "next": "Next >",
        "last": "Last >>",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "pageTotals": "Page Totals",
        "totalInventoryAmount": "Total Inventory Amount",
        "totalBalance": "Total Balance"
    },

    "ProductsSettingsTabs": {
        "settings": "Settings"
    },
    "ProductsSettings": {
        "smallTable": {
            "categoryName": "Category Name",
            "codeMask": "Code Mask"
        },
        "table": {
            "name": "Name",
            "invoiceType": "Invoice Type",
            "category": "Category",
            "type": "Type"
        },
        "instructions": "Instructions:",
        "text1": "Category Name is the category name for the product",
        "text2": "Code Mask is the Mask used to create the product code. Character \"*\", produces increasing numbering. Example: Abc-***, produces code Abc-001",
        "save": "Save",
        "categorySettings": "Category Settings",
        "taxes": "Taxes",
        "proposedMyDataValue": "Default myDATA table",
        "vat%": "VAT %",
        "0%vatReason": "0% VAT Reason",
        "otherTaxes": "Other Taxes",
        "withHoldTaxes": "Withhold Taxes",
        "stamp": "Stamp",
        "fees": "Fees",
        "measurementUnit": "Measurement Unit"
    },
    "SalesNewTabs": {
        "sales": "Sales"
    },
    "SalesSearchTabs": {
        "search": "Search"
    },
    "QuotationsNewTabs": {
        "quotations": "Quotations"
    },
    "QuotationsSearchTabs": {
        "search": "Search"
    },
    "SalesNew": {
        "clientTable": {
            "code": "Code",
            "name": "Name",
            "phone": "Phone",
            "email": "Email",
            "vatNumber": "Vat Number"
        },
        "productTable": {
            "title": "Products",
            "code": {
                "code": "Code",
                "placeholder": "Select Code"
            },
            "name": {
                "name": "Product Name",
                "placeholder": "Select Product Name"
            },
            "quantity": "Quantity",
            "mu": "M.U.",
            "unitPrice": "Unit Price",
            "discount": "Discount",
            "vat": "V.A.T.%",
            "netValue": "Net Value",
            "vatValue": "Vat Value",
            "taxes": "Taxes",
            "totalValue": "Total Value"
        },
        "extraDataTable": {
            "title": "Extra Data",
            "locationDelivery": "Location of Delivery",
            "locationCountry": {
                "locationCountry": "Location Country",
                "required": "Location Country is required."
            },
            "locationCity": {
                "locationCity": "Location City",
                "required": "Location City is required."
            },
            "locationAddress": {
                "locationAddress": "Location Address",
                "required": "Location Address is required."
            },
            "locationPostalCode": {
                "locationPostalCode": "Location Postal Code",
                "required": "Location Postal Code is required."
            },
            "wayOfSendingGoods": "Way of sending goods",
            "otherTaxes": "Other Taxes",
            "withHoldTaxes": "Withhold Taxes",
            "goodsSendDate": "Goods Send Date",
            "carNumber": "Car Number",
            "fees": "Fees",
            "stampDuty": "Stamp Duty"
        },
        "productCodeTable": {
            "code": "Code",
            "alternativeCode": "Alternative Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "quickClientTable": {
            "name": "Client Name",
            "vatCategory": "Vat Category",
            "vatNumber": "Vat Number",
            "phone": "Phone Number",
            "email": "Email",
            "address": "Address",
            "city": "City"
        },
        "corelatedTable": {
            "name": "Client Name",
            "clientVat": "Client VAT",
            "documentType": "DocumentType",
            "date": "Date",
            "preNumber": "Pre Number",
            "number": "Number",
            "totalAmount": "Total Amount"
        },
        "salesTaxesTables": {
            "vat%": "VAT %",
            "netValue": "Net Value €",
            "vat": "VAT €",
            "withHoldTaxes": "WithHold Taxes",
            "otherTaxes": "Other Taxes",
            "fees": "Fees",
            "stampDuty": "Stamp Duty"
        },
        "installationTable": {
            "type": "Type",
            "address": "Address"
        },
        "totalsTable": {
            "title": "Totals",
            "totalQuantity": "Total Quantity",
            "totalBeforeDiscount": "Total Before Discount",
            "totalDiscount": "Total Discount",
            "totalNetValue": "Total Net Value",
            "totalVatAmount": "Total VAT Amount",
            "totalWithHoldTaxesAmount": "Total WithHold Taxes Amount",
            "totalTaxesAmount": "Total Taxes Amount",
            "totalAmount": "Total Amount",
            "paymentAmount": "Payment Amount"
        },
        "message": "Please select Document Type first..",
        "message2": "Please select client first...",
        "addNewClient": "Add new client",
        "loading": "Loading..",
        "messageProductList": "Product list should not be empty.",
        "myDataStatus": "My Data Status",
        "files": "Files",
        "DocumentType": "Document Type",
        "Date": "Date",
        "time": "Time",
        "installation": "Installation",
        "preNumber": {
            "preNumber": "Pre Number",
            "required": "PreNumber is required."
        },
        "number": {
            "number": "Number",
            "placeholder": "Number",
            "required": "Number is required."
        },
        "corelatedDocument": {
            "corelatedDocument": "Correlated Document",
            "placeholder": "Select Correlated Document",
            "required": "Correlated Document is required."
        },
        "newRetailClient": {
            "newRetailClient": "New Retail Client",
            "placeholder": "Add new retail client name"
        },
        "client": {
            "client": "Client",
            "placeholder": "Select Client",
            "required": "Client is required."
        },
        "clientInstallation": {
            "clientInstallation": "Client Installation",
            "placeholder": "Client Installation"
        },
        "vat": "VAT",
        "email": {
            "email": "Email",
            "required": "Email or Phone is required."
        },
        "phone": {
            "phone": "Phone",
            "required": "Email or Phone is required."
        },
        "address": "Address",
        "doy": "DOY",
        "city": "City",
        "pc": "PC",
        "paymentType": {
            "paymentType": "Payment Type",
            "required": "Payment Type is required."
        },
        "displayAltName": "Display Alternate Name On Print",
        "displayAltCode": "Display Alternate Code On Print",
        "posBankAccount": "POS/Bank Account",
        "posBankAccountRequired": "POS/Bank Account is required!",
        "salePurpose" : "Sale Purpose",
        "salesNotes": "Sales Notes",
        "addNotes": "Add Notes"
    },
    "SalesNewView": {
        "clientTable": {
            "code": "Code",
            "name": "Name",
            "phone": "Phone",
            "email": "Email",
            "vatNumber": "Vat Number"
        },
        "productTable": {
            "title": "Products",
            "code": "Code",
            "name": "Product Name",
            "quantity": "Quantity",
            "mu": "M.U.",
            "unitPrice": "Unit Price",
            "discount": "Discount",
            "vat": "VAT %",
            "netValue": "Net Value",
            "vatValue": "Vat Value",
            "taxes": "Taxes",
            "totalValue": "Total Value"
        },
        "extraDataTable": {
            "title": "Extra Data",
            "locationDelivery": "Location of Delivery",
            "locationCountry": {
                "locationCountry": "Location Country",
                "required": "Location Country is required."
            },
            "locationCity": {
                "locationCity": "Location City",
                "required": "Location City is required."
            },
            "locationAddress": {
                "locationAddress": "Location Address",
                "required": "Location Address is required."
            },
            "locationPostalCode": {
                "locationPostalCode": "Location Postal Code",
                "required": "Location Postal Code is required."
            },
            "wayOfSendingGoods": "Way of sending goods",
            "otherTaxes": "Other Taxes",
            "withHoldTaxes": "Withhold Taxes",
            "goodsSendDate": "Goods Send Date",
            "carNumber": "Car Number",
            "fees": "Fees",
            "stampDuty": "Stamp Duty"
        },
        "productCodeTable": {
            "code": "Code",
            "alternativeCode": "Alternative Code",
            "productName": "Product Name",
            "alternativeName": "Alternative Name"
        },
        "quickClientTable": {
            "name": "Client Name",
            "vatCategory": "Vat Category",
            "vatNumber": "Vat Number",
            "phone": "Phone Number",
            "email": "Email",
            "address": "Address",
            "city": "City"
        },
        "corelatedTable": {
            "name": "Client Name",
            "clientVat": "Client VAT",
            "documentType": "DocumentType",
            "date": "Date",
            "preNumber": "Pre Number",
            "number": "Number",
            "totalAmount": "Total Amount"
        },
        "salesTaxesTables": {
            "vat%": "VAT %",
            "netValue": "Net Value €",
            "vat": "VAT €",
            "withHoldTaxes": "WithHold Taxes",
            "otherTaxes": "Other Taxes",
            "fees": "Fees",
            "stampDuty": "Stamp Duty"
        },
        "installationTable": {
            "type": "Type",
            "address": "Address"
        },
        "totalsTable": {
            "title": "Totals",
            "totalQuantity": "Total Quantity",
            "totalBeforeDiscount": "Total Before Discount",
            "totalDiscount": "Total Discount",
            "totalNetValue": "Total Net Value",
            "totalVatAmount": "Total VAT Amount",
            "totalWithHoldTaxesAmount": "Total WithHold Taxes Amount",
            "totalTaxesAmount": "Total Taxes Amount",
            "totalAmount": "Total Amount",
            "paymentAmount": "Payment Amount"
        },
        "message": "Please select Document Type first..",
        "message2": "Please select client first...",
        "myDataErrors" : "Show MyData Error",
        "sendToMyData" : "Send To MyData",
        "addNewClient": "Add new client",
        "loading": "Loading..",
        "messageProductList": "Product list should not be empty.",
        "myDataStatus": "My Data Status",
        "files": "Files",
        "DocumentType": "Document Type",
        "Date": "Date",
        "time": "Time",
        "installation": "Installation",
        "preNumber": {
            "preNumber": "Pre Number",
            "required": "PreNumber is required."
        },
        "number": {
            "number": "Number",
            "placeholder": "Number",
            "required": "Number is required."
        },
        "corelatedDocument": {
            "corelatedDocument": "Correlated Document",
            "placeholder": "Select Correlated Document",
            "required": "Correlated Document is required."
        },
        "corelatedCreditDocument": "Correlated/Credit Document",
        "corelatedConvertDocument": "Correlated/Convert Document",
        "newRetailClient": {
            "newRetailClient": "New Retail Client",
            "placeholder": "Add new retail client name"
        },
        "client": {
            "client": "Client",
            "placeholder": "Select Client",
            "required": "Client is required."
        },
        "clientInstallation": {
            "clientInstallation": "Client Installation",
            "placeholder": "Client Installation"
        },
        "vat": "VAT",
        "email": {
            "email": "Email",
            "required": "Email or Phone is required."
        },
        "phone": {
            "phone": "Phone",
            "required": "Email or Phone is required."
        },
        "address": "Address",
        "doy": "DOY",
        "city": "City",
        "pc": "PC",
        "paymentType": {
            "paymentType": "Payment Type",
            "required": "Payment Type is required."
        },
        "posBankAccount": "POS/Bank Account",
        "salePurpose" : "Sale Purpose",
        "salesNotes": "Sales Notes",
        "addNotes": "Add Notes",
        "warning": "Warning!!",
        "warningMessage": "All data not saved will be lost, Do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "SalesNewEdit": {
        "tableProduct": {
            "code": "Code",
            "productName": "Product Name",
            "alternateName": "Alternative Name"
        },
        "tableClient": {
            "code": "Code",
            "name": "Name",
            "phone": "Phone",
            "email": "Email",
            "vatNumber": "Vat Number"
        },
        "tableClientInstallations": {
            "type": "Type",
            "address": "Address"
        },
        "table": {
            "clientName": "Client Name",
            "clientVat": "Client VAT",
            "documentType": "Document Type",
            "date": "Date",
            "preNumber": "Pre Number",
            "number": "Number",
            "totalAmount": "Total Amount"
        },
        "tableClientProducts": {
            "productCode": {
                "productCode": "Product Code",
                "placeholder": "Select Product Code"
            },
            "productName": {
                "productName": "Product Name",
                "placeholder": "Select Product Name"
            },
            "quantity": "quantity",
            "mu": "M.U.",
            "unitPrice": "Unit Price",
            "discount": "Discount",
            "vat%": "VAT%",
            "netValue": "Net Value",
            "vatValue": "Vat Value",
            "taxes": "Taxes",
            "totalValue": "Total Value"
        },
        "tableQuickClient": {
            "clientName": "Client Name",
            "vatCategory": "Vat Category",
            "vatNumber": "Vat Number",
            "phoneNumber": "Phone Number",
            "email": "Email",
            "address": "Address",
            "city": "City"
        },
        "tableSalesTaxes": {
            "vat%": "VAT %",
            "netValue": "Net Value €",
            "vat": "VAT €",
            "withholdTaxes": "Withhold Taxes",
            "otherTaxes": "Other Taxes",
            "fees": "Fees",
            "stampDuty": "Stamp Duty"
        },
        "message": "Please select client first..",
        "message2": "Product list should not be empty.",
        "loading": "Loading...",
        "wayOfSendingGoods": "Way of sending goods",
        "carNumber": "Car Number",
        "otherTaxes": "Other Taxes",
        "withholdTaxes": "Withhold Taxes",
        "goodsSendDate": "Goods Send Date",
        "fees": "Fees",
        "stampDuty": "Stamp Duty",
        "myDataStatus": "My Data Status:",
        "files": "Files",
        "time": "Time",
        "installation": "Installation",
        "preNumber": "Pre Number",
        "number": "Number",
        "correlatedDocument": {
            "correlatedDocument": "Correlated Document",
            "placeholder": "Select Correlated Document",
            "required": "Corelated Document is required"
        },
        "client": {
            "client": "Client",
            "placeholder": "Select Client"
        },
        "newRetailClient": {
            "newRetailClient": "New Retail Client",
            "placeholder": "Add new retail client name"
        },
        "clientIsRequired": "Client is required",
        "clientInstallation": {
            "clientInstallation": "Client Installation",
            "placeholder": "Select Client Installation"
        },
        "vat": "VAT",
        "emailOrPhoneIsRequired.": "Email or Phone is required.",
        "phone": "Phone",
        "address": "Address",
        "doy": "DOY",
        "city": "City",
        "paymentType": "Payment Type",
        "posBankAccount": "POS/Bank Account",
        "salePurpose": "Sale Purpose",
        "totals": {
            "titles": "Totals",
            "totalQuantity": "Total Quantity",
            "totalBeforeDiscount": "Total Before Discount",
            "totalDiscount": "Total Discount",
            "totalNetValue": "Total Net Value",
            "totalVATAmount": "Total VAT Amount",
            "totalWithHoldTaxesAmount": "Total WithHold Taxes Amount",
            "totalTaxesAmount": "Total Taxes Amount",
            "totalAmount": "Total Amount",
            "paymentAmount": "Payment Amount"
        },
        "sales": "Sales",
        "addNotes": "Add Notes",
        "warning": "Warning!!",
        "warningMessage": "All data not saved will be lost, Do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "SalesSearchEmailButton": {
        "title": "Send Email",
        "message1": {
            "message1": "Send Email to Existing Contact Points:",
            "placeholder": "Select one or more contact points"
        },
        "message2:": {
            "message2": "Send Email to Custom Email Addresses:",
            "placeholder": "Please write multiple emails comma separated"
        },
        "required": "Please select at least one email address.",
        "emailError": "Please input a correct email address.",
        "close": "Close",
        "send": "Send"
    },
    "SalesSearch": {
        "table": {
            "date": "Date",
            "client": "Client",
            "documentType": "Document Type",
            "number": "Number",
            "totalNetValue": "Total Net Value",
            "totalVatValue": "Total Vat Value",
            "totalSum": "Total Sum",
            "myDataStatus": "My Data Status",
            "providerChannel": "Provider Channel"
        },
        "table2": {
            "documentType": "Document Type",
            "clientNameFrom": "Client Name/VAT Number",
            "clientNameTo": "Client Name To",
            "totalSumFrom": "Total Sum From",
            "totalSumTo": "Total Sum To",
            "preNumberFrom": "Pre Number From",
            "preNumberTo": "Pre Number To",
            "numberFrom": "Number From",
            "numberTo": "Number To",
            "paymentWays": "Payment Ways",
            "myDataStatus": "My Data Status",
            "providerChannel": "Provider Channel",
            "productName" : "Including product with name",
            "paymentStatus": "Payment Status",
            "notes": "Notes"
        }
    },
    "QuickRetailSalesNew": {
        "smallTable": {
            "code": "Code",
            "name": "Name",
            "Phone": "Phone",
            "email": "Email"
        },
        "table": {
            "productName": "Product Name",
            "quantity": "Quantity",
            "price": "Price",
            "totals": "Totals"
        },
        "client": {
            "client": "Client",
            "placeholder": "Search client by name, email and code."
        },
        "client2": {
            "client2": "Client2",
            "placeholder": "Add Client Name",
            "question": "Is new client?"
        },
        "files": "Files",
        "address": {
            "address": "Address",
            "placeholder": "Enter Address"
        },
        "phone": {
            "phone": "Phone Number",
            "placeholder": "Enter Phone Number"
        },
        "email": {
            "email": "Email",
            "placeholder": "eg. example@example.com",
            "warning": "Invalid email address."
        },
        "message": "Please select client first..",
        "messageTable": "Table should not be empty.",
        "sendEmail": "Send Email",
        "cash": "CASH",
        "issue": "ISSUE",
        "products": "Products",
        "searchResult": "Search Result",
        "notFound": "Not found...",
        "recommendedProducts": "Recommended Products",
        "cashRegister": "CASH REGISTER",
        "paymentAnalysis": "Payment Analysis",
        "totalAmount": "Total Amount:",
        "cash2": {
            "cash2": "Cash:",
            "placeholder": "Amount"
        },
        "clientPaymentTotals": "Client Payment Totals:",
        "clientChange": {
            "clientChange": "Client Change:",
            "issue": "ISSUE"
        }
    },
    "QuickRetailSearchTabs": {
        "table": {
            "date": "Date",
            "client": "Client",
            "preNumber": "Pre Number",
            "number": "Number",
            "products": "Products",
            "totalSum": "Total Sum"
        },
        "clientNameFrom": "Client Name",
        "clientNameTo": "Client Name To",
        "totalSumFrom": "Total Sum From",
        "totalSumTo": "Total Sum To",
        "preNumberFrom": "Pre Number From",
        "preNumberTo": "Pre Number To",
        "numberFrom": "Number From",
        "numberTo": "Number To",
        "paymentWays": "Payment Ways",
        "products": "Products"
    },
    "SalesClientPaymentsTabs": {
        "general": "General"
    },
    "SalesClientPaymentsNew": {
        "dropTable": {
            "code": "Code",
            "name": "Name",
            "phone": "Phone",
            "email": "Email"
        },
        "smallTable": {
            "name": "Name",
            "serialNumber": "Registration Number"
        },
        "bankTable": {
            "accountName": "Bank Account Name",
            "bankName": "Bank Name",
            "bankAccountName": "Bank Account Number"
        },
        "posTable": {
            "posName": "POS name",
            "posRegistrationNumber": "POS registration number",
            "amount": "amount",
            "notes": "Notes"
        },
        "bank2Table": {
            "bankAccount": "Bank Account",
            "accountNumber": "Account Number",
            "amount": "Amount",
            "notes": "Notes"
        },
        "checkTable": {
            "startDate": "Start Date",
            "endDate": "End Date",
            "amount": "Amount",
            "notes": "Notes"
        },
        "message": "Please select document type first..",
        "documentTypes": "Document Types",
        "files": "Files",
        "date": "Date",
        "installation": {
            "installation": "Installation",
            "required": "Installation is required."
        },
        "preNumber": "Pre Number",
        "number": {
            "number": "Number",
            "placeholder": "Number"
        },
        "paymentType": "Payment Type",
        "client": {
            "client": "Client",
            "placeholder": "Select Client",
            "required": "Client is required."
        },
        "vatNumber": "VAT number",
        "address": "Address",
        "country": "Country",
        "phone": "Phone",
        "email": "Email",
        "reason": "Reason",
        "paymentAmount": {
            "paymentAmount": "Payment Amount",
            "placeholder": "Enter Amount"
        },
        "bankAccountData": "Bank Account Data",
        "chequeData": "Cheque Data",
        "posData": "POS Data",
        "paymentNotes": "Payment Notes",
        "addNotes": "Add Notes",
        "warning": "Warning!!",
        "message2": "All data not saved will be lost, Do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "SalesClientPaymentsSearchTabs": {
        "search": "Search"
    },
    "SalesClientPaymentsSearch": {
        "table": {
            "date": "Date",
            "client": "Client",
            "documentType": "Document Type",
            "preNumberAndNumber": "Numbering",
            "paymentType": "Payment Type",
            "amount": "Amount"
        },
        "tableFilter": {
            "documentType": "Document Type",
            "clientNameFrom": "Client Name",
            "clientNameTo": "Client Name To",
            "paymentTypes": "Payment Types",
            "amountFrom": "Amount From",
            "amountTo": "Amount To"
        }
    },
    "SalesClientPaymentsNewEdit": {
        "dropTable": {
            "code": "Code",
            "name": "Name",
            "phone": "Phone",
            "email": "Email"
        },
        "smallTable": {
            "name": "Name",
            "serialNumber": "Registration Number"
        },
        "bankTable": {
            "accountName": "Bank Account Name",
            "bankName": "Bank Name",
            "bankAccountName": "Bank Account Number"
        },
        "posTable": {
            "posName": "POS name",
            "posRegistrationNumber": "POS registration number",
            "amount": "amount",
            "notes": "Notes"
        },
        "bank2Table": {
            "bankAccount": "Bank Account",
            "accountNumber": "Account Number",
            "amount": "Amount",
            "notes": "Notes"
        },
        "checkTable": {
            "startDate": "Start Date",
            "endDate": "End Date",
            "amount": "Amount",
            "notes": "Notes"
        },
        "message": "Please select document type first..",
        "documentTypes": "Document Types",
        "files": "Files",
        "date": "Date",
        "installation": {
            "installation": "Installation",
            "required": "Installation is required."
        },
        "preNumber": "Pre Number",
        "number": {
            "number": "Number",
            "placeholder": "Number"
        },
        "paymentType": "Payment Type",
        "client": {
            "client": "Client",
            "placeholder": "Select Client",
            "required": "Client is required."
        },
        "vatNumber": "VAT number",
        "address": "Address",
        "country": "Country",
        "phone": "Phone",
        "email": "Email",
        "reason": "Reason",
        "paymentAmount": {
            "paymentAmount": "Payment Amount",
            "placeholder": "Enter Amount"
        },
        "bankAccountData": "Bank Account Data",
        "chequeData": "Cheque Data",
        "posData": "POS Data",
        "paymentNotes": "Payment Notes",
        "addNotes": "Add Notes",
        "warning": "Warning!!",
        "message2": "All data not saved will be lost, Do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "SalesAutomaticSalesNewTabs": {
        "general": "General"
    },
    "SalesAutomaticSalesNew": {
        "saleActive": "Sale Active:",
        "name": {
            "name": "Name",
            "placeholder": "Add Name",
            "required": "Name is required field."
        },
        "files": "Files",
        "startDate": {
            "startDate": "Start Date",
            "required": "Start Date is required field."
        },
        "endDate": "End Date",
        "issueInvoiceEvery": "Issue invoice every",
        "days": {
            "days": "Days",
            "required": "Days is required field."
        },
        "or": "OR",
        "ofEachMonth": "of each month",
        "require": "Day of month is required field.",
        "invoiceData": "Invoice Data",
        "createNewSalesDocument": "Create New Sales Document",
        "selectSalesTemplate": "Select Sales Template",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "SalesAutomaticSalesSearchTabs": {
        "search": "Search"
    },
    "SalesAutomaticSalesSearch": {
        "table": {
            "client": "Client",
            "dateStarted": "Date Started",
            "endDate": "End date",
            "issueInterval": "Issue interval",
            "documentType": "Document Type",
            "totalSum": "Total Sum",
            "active": "Active",
            "lastLog": "Last Log",
            "failReason": "Fail Reason"
        },
        "clientNameFrom": "Client Name From",
        "clientNameTo": "Client Name To",
        "dateStartedFrom": "Date Started From",
        "dateStartedTo": "Date Started To",
        "endDateFrom": "End Date From",
        "endDateTo": "End Date To",
        "documentType": "Document Type",
        "totalSumFrom": "Total Sum From",
        "totalSumTo": "Total Sum To",
        "active": "Active",
        "inActive": "InActive",
        "all": "All",
        "null": "Null (Blank)",
        "success": "Success",
        "fail": "Fail"
    },
    "SalesMyDataTabs": {
        "myDataReport": "My Data Report"
    },
    "SalesMyData": {
        "thisMonth": "This Month",
        "allDocuments": "All Documents",
        "html": "Export HTML To Doc",
        "table": {
            "date": "Date",
            "client": "Client",
            "clientVat": "Client VAT",
            "invoiceType": "Invoice Type",
            "number": "Number",
            "netValue": "Net Value",
            "vatAmount": "VAT Amount",
            "totalValue": "Total Value",
            "erpStatus": "ERP Status",
            "myDataStatus":"MyData Status",
            "changeClassifications": "View Classifications",
            "classificationsModalTitle": "MyData Classifications",
            "classificationsModalDesc": "From here you can view and edit the myData characterizations of each product included in the invoice clicking on Save",
            "classificationsModalClose": "Close",
            "classificationsModalSave": "Save"
        },
        "table2": {
            "allDocuments": "All Documents",
            "onlyDifferences": "Only Differences",
            "onlyTheSent": "Only the sent",
            "onlyTheFailed": "Only the failed",
            "onlyFromSales": "Only From Sales",
            "onlyFromAccounting": "Only From Accounting",
            "onlyFromMyData": "Only from MyData",
            "onlyFromMyProvider": "Only from Provider"
        },
        "smallTable": {
            "client": "Client",
            "vatNumber": "Vat Number",
            "phoneNumber": "Phone Number:"
        },
        "filterBy": "Filter By",
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "invoiceType": "Invoice Type",
        "invoiceNumberFrom": "Invoice Number From:",
        "invoiceNumberTo": "Invoice Number To:",
        "client": {
            "client": "Client",
            "placeholder": "Select Client"
        },
        "showFilter": "Show Filter:",
        "showDocumentsFrom": "Show Documents From:",
        "showDocumentsFromChannel": "Show Documents From Channel:",
        "applyFilter": "Apply filter",
        "myDataReport": "MyData Report",
        "page": "Page",
        "of": "of",
        "first": "<< First",
        "previous": "< Previous",
        "next": "Next >",
        "last": "Last >>",
        "pageTotals": "Page Totals",
        "TotalsERP": "ERP Totals",
        "TotalsMyData": "MyData Totals",
        "totalNetValue": "Total Net Value",
        "totalsCount": "Total Count",
        "totalVatAmount": "Total VAT Amount",
        "totalValue": "Total Value",
        "differences": "Differences",
        "discord": "Result: Inconsistency",
        "discordOk": "Result: It is in agreement",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "message": "Please select filters first and press \"Apply filters\""
    },
    "SalesBalanceSheetTabs": {
        "balanceSheet": "Balance Sheet"
    },
    "SalesBalanceSheet": {
        "table": {
            "date": "Date",
            "client": "Client",
            "clientVat": "Client VAT",
            "invoiceType": "Invoice Type",
            "providerChannel": "Provider Channel",
            "number": "Number",
            "netValue": "Net Value",
            "vatAmount": "VAT Amount",
            "totalValue": "Total Value",
            "paymentType": "Payment Type",
            "vehicleNumber": "Vehicle Number"
        },
        "table2": {
            "clientFrom": "Client From",
            "clientTo": "Client To"
        },
        "table3": {
            "clientName": "Client Name",
            "vatNumber": "Vat Number",
            "phoneNumber": "Phone Number:"
        },
        "filterBy": "Filter By",
        "dateFrom": "Date From",
        "clientFrom": {
            "clientFrom": "Client From",
            "placeholder": "Select Client"
        },
        "invoiceType": "Invoice Type",
        "providerChannel": "Provider Channel",
        "showAutomaticSales": "Show Automatic Sales",
        "dateTo": "Date To",
        "clientTo": {
            "clientTo": "Client To",
            "placeholder": "Select Client"
        },
        "paymentType": "Payment Type",
        "vehicleNumber": "Vehicle Number",
        "applyFilter": "Apply filter",
        "salesBalance": "Sales Balance",
        "page": "Page",
        "of": "of",
        "first": "<< First",
        "previous": "< Previous",
        "next": "Next >",
        "last": "Last >>",
        "pageTotals": "Page Totals",
        "totalNetValue": "Total Net Value",
        "totalVatAmount": "Total VAT Amount",
        "totalValue": "Total Value",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "message": "Please select filters first and press \"Apply filters\""
    },
    "SalesGraphicReportTabs": {
        "graphicReport": "Graphic Report"
    },
    "SalesGraphicReport": {
        "table": {
            "clientFrom": "Client From",
            "clientTo": "Client To"
        },
        "table2": {
            "clientName": "Client Name",
            "vatNumber": "Vat Number",
            "phoneNumber": "Phone Number:"
        },
        "filterBy": "Filter By",
        "dateFrom": "Date From",
        "clientFrom": {
            "clientFrom": "Client From",
            "placeholder": "Select Client"
        },
        "invoiceType": "Invoice Type",
        "dateTo": "Date To",
        "clientTo": {
            "clientTo": "Client To",
            "placeholder": "Select Client"
        },
        "paymentType": "Payment Type",
        "applyFilter": "Apply filter",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "message": "Please select filters first and press \"Apply filters\""
    },
    "SalesClientPaymentReportTabs": {
        "clientPaymentReport": "Client Payment Report"
    },
    "SalesClientPaymentReport": {
        "table": {
            "date": "Date",
            "clientName": "Client Name",
            "clientVat": "Client VAT",
            "invoiceType": "Invoice Type",
            "number": "Number",
            "paymentAmount": "Payment Amount",
            "paymentType": "Payment Type"
        },
        "table2": {
            "clientFrom": "Client From",
            "clientTo": "Client To"
        },
        "table3": {
            "clientName": "Client Name",
            "vatNumber": "Vat Number",
            "phoneNumber": "Phone Number:"
        },
        "filterBy": "Filter By",
        "dateFrom": "Date From",
        "clientFrom": {
            "clientFrom": "Client From",
            "placeholder": "Select Client"
        },
        "invoiceType": "Invoice Type",
        "dateTo": "Date To",
        "clientTo": {
            "clientTo": "Client To",
            "placeholder": "Select Client"
        },
        "paymentType": "Payment Type",
        "applyFilter": "Apply filter",
        "clientPaymentBalance": "Client Payments Balance",
        "page": "Page",
        "of": "of",
        "first": "<< First",
        "previous": "< Previous",
        "next": "Next >",
        "last": "Last >>",
        "pageTotals": "Page Totals",
        "paymentAmount": "Payment Amount",
        "printResults": {
            "printResults": "Print Results",
            "printer": "Printer",
            "printToCSV": "Print To CSV",
            "printToPDF": "Print To PDF",
            "printToExcel": "Print To Excel",
            "printToWord": "Print To Word"
        },
        "message": "Please select filters first and press \"Apply filters\""
    },
    "SalesGeneralSettingsTabs": {
        "settings": "Settings"
    },
    "SalesGeneralSettings": {
        "name": "Name",
        "number": "Number",
        "type": "Type",
        "salesDocument": "Sales Document:",
        "waysOfSendingGoods": "Ways of sending goods:",
        "carNumbers": "Car Numbers:",
        "forbidChangeInPricesInSalesProducts": "Forbid change in prices in Sales products",
        "paymentTypes": "Payment Types:",
        "paymentOptions": "Payment Options:",
        "paymentType": "Payment Type -",
        "posBankAccount": "Pre-selected POS/Bank Account",
        "createAutomaticPaymentInSales": "Create Automatic Payment in Sales",
        "paymentDocumentType": "Payment Document Type",
        "preNumber": "Pre Number",
        "paymentReason": {
            "paymentReason": "Payment Reason",
            "placeholder": "Add Payment Reason"
        },
        "addWildcard": "Add Wildcard",
        "wildCards": "Wildcards -",
        "clickOnWildcardToAddInThePaymentReason": "Click on wildcard to add in the payment reason."
    },
    "SalesQuickRetailSales": {
        "activated": "Deactivated",
        "deactivated": "Activated",
        "defaultSalesDocumentType": "Default Sales Document Type",
        "activateCashRegister": "Activate Cash Register",
        "allowCreationOfNewClient": "Allow creation of new client",
        "allowSelectionOfClient": "Allow selection of client",
        "defaultRetailClient": "Default Retail Client",
        "defaultSendEmailStatus": "Default \"Send email\" status",
        "forbidChangeInPricesInSalesProducts": "Forbid change in prices in Sales products",
        "defaultProducts": "Default Products",
        "defaultInstallation": "Default Installation",
        "defaultPreNumber": "Default Pre Number",
        "paymentWay1Name": {
            "paymentWay1Name": "Payment way 1 name",
            "placeholder": "Add name"
        },
        "paymentType1": "Payment type 1",
        "active": "Active",
        "createAutomaticPayment": "Create Automatic Payment",
        "paymentWay2Name": {
            "paymentWay2Name": "Payment way 2 name",
            "placeholder": "Add name"
        },
        "paymentType2": "Payment type 2",
        "paymentWay3Name": {
            "paymentWay3Name": "Payment way 3 name",
            "placeholder": "Add name"
        },
        "paymentType3": "Payment type 3",
        "preSelectedPaymentWay": "Pre Selected Payment Way",
        "warning": "Warning!!",
        "message": "It may clear or change existing setting. Do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "ClientsNewTabs": {
        "general": "General",
        "installations": "Installations",
        "communicationHistory": "Communication History",
        "information": "Information",
        "notes": "Notes",
        "accounting": "Accounting"
    },
    "ClientsGeneralSearchTabs": {
        "search": "Search"
    },
    "ClientsMovementNewTabs": {
        "general": "General"
    },
    "ClientsMovementSearchTabs": {
        "general": "General"
    },
    "ReportsClientsListTabs": {
        "general": "General"
    },
    "ReportsClientsMovementsTabs": {
        "general": "General"
    },
    "ReportsClientsSettingsTabs": {
        "general": "General",
        "massEmail": "Mass Email"
    },
    "QuickRetailSalesNewTabs": {
        "retail": "retail"
    },
    "QuickRetailSalesSearchTabs": {
        "search": "Search"
    },
    "ClientsNewGeneral": {
        "files" : "Files",
        "message": "Please select category first..",
        "details": "Get Details",
        "clientCategory": "Category",
        "systemCode": "System Code",
        "manualCode": {
            "code": "Manual Code",
            "eg": "eg. mcc-001"
        },
        "name" : {
            "name": "Clients Name ",
            "placeholder": "Enter Clients Name",
            "required": "Clients Name is required.",
            "exist": "Clients Name already exists."
        },
        "smallName" : {
            "smallName": "Clients Small Name",
            "placeholder": "Enter Clients Small Name"
        },
        "vatCategory": {
            "vatCategory": "VAT Category",
            "required": "VAT Category is required."
        },
        "0vatReason": {
            "0vatReason": "0% VAT Reason",
            "required": "VAT Reason is required."
        },
        "customVat": {
            "customVat": "Custom VAT %",
            "placeholder": "Custom VAT",
            "required": "VAT Reason is required."
        },
        "vatNumber": {
            "vatNumber": "VAT Number",
            "placeholder": "Add Vat Number",
            "required": "Vat Number is required."
        },
        "doy": {
            "doy": "DOY",
            "required": "DOY is required"
        },
        "activity": {
            "activity": "Activity",
            "placeholder": "Enter Activity",
            "required": "Activity is required."
        },
        "amka": {
            "amka": "AMKA",
            "placeholder": "Enter AMKA",
            "required": "Email or Phone or AMKA is required."
        },
        "country": {
            "country": "Country",
            "required": "Country is required."
        },
        "address": {
            "address": "Address",
            "placeholder": "Enter Address",
            "required": "Address is required."
        },
        "city": {
            "city": "City",
            "placeholder": "Enter City",
            "required": "City is required."
        },
        "postalCode": {
            "postalCode": "Postal Code",
            "placeholder": "Enter Postal Code",
            "required": "Postal Code is required."
        },
        "email": {
            "email": "Email",
            "eg": "eg. example@example.com",
            "invalid": "Invalid email address.",
            "required": "Email or Phone is required",
            "required2": "Email or Phone or AMKA is required."
        },
        "phone": {
            "phone": "Phone",
            "placeholder": "Enter Phone Number"
        },
        "gemh": {
            "gemh": "GEMH no",
            "placeholder": "Enter gemhNo"
        },
        "webpage": {
            "webpage": "Webpage",
            "eg": "eg. https://www.example.com/"
        },
        "contactPoints" : {
            "title" : "Contact Points:",
            "contactName": "Contact Name",
            "mobilePhone": "Mobile Phone",
            "landLine": "Landline",
            "otherPhone": "Other Phone",
            "email": "Email",
            "contactNotes": "Contact Notes",
            "acceptNotifications": "Accept Notifications",
            "actions": "Actions"
        },
        "clientNotes" : {
            "title": "Client Notes:",
            "note": "Add Client Notes"
        }
    },
    "ClientsNewInstallations" : {
        "installations": "Installations:",
        "type": "Type",
        "address": "Address",
        "installationDoy": "Installation DOY",
        "city": "City",
        "postalCode": "Postal Code",
        "InstallationVatCategory": "Installation Vat Category",
        "0%vatReason": "0% Vat Reason",
        "customVat0": "Custom Vat 0%"
    },
    "ClientsNewCommunicationHistory" : {
        "table": {
            "date": "Date",
            "time": "Time",
            "subject": "Subject",
            "subjectPlaceholder": "Select Subject",
            "details": "Details",
            "followUpDate": "Follow Up Date",
            "createCalendar": "Create Calendar Event for Follow Up",
            "done": "Done",
            "null": "Null (Blank)",
            "yes": "Yes",
            "no": "No"
        },
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "subject": "Subject",
        "followUpDateFrom": "Follow Up Date From",
        "followUpDateTo": "Follow Up Date To",
        "done": "Done",
        "applyFilter": "Apply filter"
    },
    "ClientsNewInformation": {
        "table": {
            "description": "Description",
            "details": "Details",
            "date": "Date",
            "time": "Time",
            "lastEditedBy": "Last Edited By"
        },
        "title": "Information:",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "ClientsNewNotes": {
        "description": "Description",
        "details": "Details",
        "date": "Date",
        "time": "Time",
        "lastEditedBy": "Last Edited By",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "ClientsNewEmron": {
        "tablePassword": {
            "type": "Type",
            "username": "Username",
            "password": "Password",
            "notes": "Notes"
        },
        "stockholder": {
            "name": "Name",
            "surname": "Surname",
            "vat": "Vat",
            "position": "Position",
            "percentage": "Percentage",
            "stockValue": "Stock Value",
            "dateFrom": "Date From",
            "dateTo": "Date To"
        },
        "passwords": "Passwords:",
        "stockholders": "Stockholders:",
        "capital": "Capital",
        "placeholder": "Add value"

    },
    "ClientsNewCommunicationHistoryEdit": {
        "table1": {
            "date": "Date",
            "time": "Time",
            "subject": "Subject",
            "details": "Details",
            "followUpDate": "Follow Up Date",
            "createCalenderEvent": "Create Calendar Event for Follow Up",
            "true": "True",
            "false": "False",
            "done": "Done"
        },
        "table2": {
            "subject": "Subject",
            "followUpDateFrom": "Follow Up Date From",
            "followUpDateTo": "Follow Up Date To",
            "done": "Done",
            "null": "Null (Blank)",
            "yes": "Yes",
            "no": "No"
        },
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "subject": "Subject",
        "followUpDateFrom": "Follow Up Date From",
        "followUpDateTo": "Follow Up Date To",
        "done": "Done",
        "selectSubjects": "Select subjects.",
        "clientName": {
            "clientName": "Client Name",
            "placeholder": "Add client name."
        },
        "applyFilter": "Apply filter"
    },
    "ClientsNewInformationEdit": {
        "description": "Description",
        "details": "Details",
        "date": "Date",
        "time": "Time",
        "lastEditedBy": "Last Edited By",
        "information": "Information:",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "ClientsNewNotesEdit": {
        "table": {
            "description": "Description",
            "details": "Details",
            "date": "Date",
            "time": "Time",
            "lastEditedBy": "Last Edited By"
        },
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "ClientsNewEmronEdit": {
        "table1": {
            "type": "Type",
            "username": "Username",
            "password": "Password",
            "notes": "Notes"
        },
        "table2": {
            "name": "Name",
            "surname": "Surname",
            "vat": "Vat",
            "position": "Position",
            "percentage": "Percentage",
            "stockValue": "Stock Value",
            "dateFrom": "Date From",
            "dateTo": "Date To"
        },
        "password": "Passwords",
        "stockholders": "Stockholders",
        "capital": "Capital",
        "addValue": "Add Value"
    },
    "ClientsNewAccounting": {
        "message": "No information about this tab"
    },
    "ClientsSearch" : {
        "clientSearch": "Client Search",
        "clientName": "Client Name",
        "contactName": "Contact Name",
        "manualCode": "Manual Code",
        "clientCode": "Client Code",
        "clientCategory": "Client Category",
        "clientVatNumber": "Client Vat Number",
        "clientPhone": "Client Phone",
        "inactiveClient": "Show Inactive Clients",
        "table": {
            "clientCode": "Client Code",
            "manualCode": "Manual Code",
            "clientName": "Client Name",
            "clientCategory": "Client Category",
            "vatNo": "VAT No",
            "contactName": "Contact Name",
            "phoneNo": "Phone No",
            "amka": "Α.Μ.Κ.Α."
        }
    },
    "ClientsMovementsNew" : {
        "files": "Files",
        "message": "Please select document type first..",
        "sum": "Sum",
        "clientCode": "Client Code",
        "clientName": "Client Name",
        "amount": "Amount",
        "documentTypes": "Document Types",
        "installation": "Installation",
        "preNumber": "Pre Number",
        "number": {
            "number": "Number",
            "placeholder": "Document Number"
        },
        "date": "Date",
        "reason": {
            "reason": "Reason",
            "placeholder": "Enter Reason"
        },
        "movementsNotes": {
            "movementsNotes": "Movements Notes",
            "placeholder": "Add Movements Notes"
        },
        "code": "Code",
        "name": "Name",
        "placeholder1": "Select Client Code",
        "placeholder2": "Select Client Name"
    },
    "ClientMovementsSearch" : {
        "columns" : {
            "date": "Date",
            "reason": "Reason",
            "clientName": "Client Name",
            "clientCode": "Client Code",
            "movementCategory": "Movement Category",
            "totalAmount": "Total Amount"
        },
        "clientName": "Client Name",
        "totalAmountFrom": "Total Amount From",
        "totalAmountTo": "Total Amount To"
    },
    "ClientsReportsClientBalance": {
        "table" : {
            "tableClientName": "Client Name",
            "tableVatNumber": "VAT Number",
            "tablePhoneNumber": "Phone Number"
        },
        "tableFilter" : {
            "tableInventory": "Invetory",
            "tableClientName": "Client Name",
            "tableBalance": "Balance"
        },
        "calculateBalanceUpTo" : "Calculate balance up to:",
        "clientFrom": {
            "clientFrom": "Client From",
            "placeholder": "Select Client"
        },
        "clientTo": {
            "clientTo" : "Client To",
            "placeholder": "Select Client"
        },
        "includeInactiveClients": "Ιnclude inactive clients",
        "includeClientsWithZeroBalance": "Ιnclude clients with zero balance",
        "pleaseSelectFiltersFirstAndPressApplyFilters": "Please select filters first and press \"Apply filters\"\n",
        "applyFilter": "Apply Filter",
        "clientBalance": "Client Balance",
        "pageTotals": "Page Totals",
        "totalBalance": "Total Balance",
        "printResults": "Print Results",
        "printer" : "Printer",
        "printToCsv": "Print to CSV",
        "printToPdf": "Print to PDF",
        "printToExcel": "Print to Excel",
        "printToWord": "Print to Word"
    },
    "ClientsReportsClientMovement": {
        "table" : {
            "date": "Date",
            "invoiceType": "Invoice Type",
            "number": "Number",
            "amount": "Amount",
            "balance": "Balance",
            "sale": "Sale",
            "payment": "Payment",
            "pageTotals": "Page Totals"
        },
        "table2": {
            "thisMonth": "This Month",
            "lastMonth": "Last Month",
            "thisYear": "This Year"
        },
        "tableClient": {
            "clientName": "Client Name",
            "vatNumber": "Vat Number",
            "phone": "Phone Number:"
        },
        "tableClientFilter": {
            "includeClientsWithZeroBalance": "Ιnclude clients with zero balance",
            "includeInactiveClients": "Ιnclude inactive clients",
            "clientFrom": "Client From",
            "clientTo": "Client To"
        },
        "filterBy" : "Filter By",
        "dateFrom" : "Date From",
        "clientFrom": {
            "clientFrom": "Client From",
            "placeholder": "Select Client"
        },
        "dateTo": "Date To",
        "clientTo": {
            "clientTo": "Client To",
            "placeholder": "Select Client"
        },
        "includeClientsWithZeroBalance": "Ιnclude clients with zero balance",
        "includeInactiveClients": "Ιnclude inactive clients",
        "pleaseSelectFiltersFirstAndPressApplyFilters": "Please select filters first and press \"Apply filters\"\n",
        "applyFilter": "Apply Filter",
        "clientTab": "Client Tab",
        "clientCode": "Client Code:",
        "dateRange": "Date Range:",
        "clientDetails": "Client Details:",
        "page": "Page:",
        "of": "of",
        "first": "First",
        "previous": "Previous",
        "next": "Next",
        "last": "Last",
        "printResults": "Print Results",
        "printer" : "Printer",
        "printToCsv": "Print to CSV",
        "printToPdf": "Print to PDF",
        "printToExcel": "Print to Excel",
        "printToWord": "Print to Word"
    },
    "ReportClientIsozygio": {
        "clientsIsozygio": "Clients Isozygio",
        "table": {
            "carryOver": "Carry Over",
            "clientName": "Client Name",
            "clientCode": "Client Code",
            "clientVat": "Client VAT",
            "debit": "Debit",
            "credit": "Credit",
            "balance": "Period Balance",
            "totalBalance": "Total Balance"
        }
    },
    "ReportSupplierIsozygio": {
        "suppliersIsozygio": "Clients Isozygio",
        "table": {
            "carryOver": "Carry Over",
            "supplierCode": "Supplier Code",
            "supplierName": "Supplier Name",
            "supplierVat": "Supplier VAT",
            "debit": "Debit",
            "credit": "Credit",
            "balance": "Period Balance",
            "totalBalance": "Total Balance"
        }
    },
    "ClientsSettings": {
        "instructions": "Instructions:",
        "instructionsCategoryName": "Category Name is the category name for the client:",
        "instructionsCodeMask": "Code Mask is the Mask used to create the client code. Character \"*\", produces increasing numbering. Example: Abc-***, produces code Abc-001",
        "googleCalendarApi": "Google Calendar API",
        "clientsCommunicationHistory": "Clients Communication History",
        "subjectOptions": {
            "subjectOptions" : "Subject Options",
            "placeholder": "eg subject1, subject2"
        },
        "instructionsSubject": "Separate each option with comma \",\", without spaces",
        "clientInfoTabSettings": "Clients \"info\" tab settings",
        "addNewSection": {
            "addNewSection": "Add New Section",
            "placeholder": "Enter Section Label"
        }
    },
    "ClientsGeneralEdit" : {
        "message": "Please select category first..",
        "table": {
            "title": "Contact Points:",
            "contactName": "Contact Name",
            "mobilePhone": "Mobile Phone",
            "landLine": "Landline",
            "otherPhone": "Other Phone",
            "email": "Email",
            "contactNotes": "Contact Notes",
            "acceptNotifications": "Accept Notifications"
        },
        "bankInfoTable": {
            "title": "Bank Information:",
            "bankFriendlyName": "Friendly Name",
            "bankInstitute": "Bank Institution"
        },
        "clientActive": "Client Active:",
        "clientBalance": "Client Balance: ",
        "category" : "Category",
        "systemCode": {
            "systemCode": "System Code",
            "placeholder": "eg. sc-***"
        },
        "manualCode":{
            "manualCode": "Manual Code",
            "placeholder": "eg. mcc-001"
        },
        "name": {
            "name": "Name",
            "placeholder": "Enter name",
            "required": "Name is required. "
        },
        "smallName": {
            "smallName": "Small Name",
            "placeholder": "Enter small name"
        },
        "files": "Files",
        "vatCategory": {
            "vatCategory": "Vat Category",
            "required": "VAT Category is required."
        },
        "0VatReason": {
            "0VatReason": "0% VAT Reason",
            "required": "0% VAT Reasons are required"
        },
        "customVat%": {
            "customVat%": "Custom VAT %",
            "placeholder": "Custom VAT",
            "required": "Custom VAT is required"
        },
        "vatNumber": {
            "vatNumber": "VAT Number",
            "placeholder": "Add Vat Number",
            "required": "VAT Number is required"
        },
        "getDetails": "Get Details",
        "doy": {
            "doy": "DOY",
            "required": "DOY is required"
        },
        "activity": {
            "activity": "Activity ",
            "placeholder": "Enter Activity",
            "required": "Activity is required"
        },
        "amka": {
            "amka": "AMKA ",
            "placeholder": "Enter AMKA",
            "required": "Email or Phone or AMKA is required"
        },
        "country": {
            "country": "Country",
            "required": "Country is required"
        },
        "address": {
            "address": "Address",
            "placeholder": "Enter Address ",
            "required": "Address is required"
        },
        "city": {
            "city": "City",
            "placeholder": "Enter City ",
            "required": "City is required"
        },
        "postalCode": {
            "postalCode": "Postal Code",
            "placeholder": "Enter Postal Code ",
            "required": "Postal Code is required."
        },
        "email": {
            "email": "Email",
            "placeholder": "eg. example@example.com ",
            "error": "Invalid email address",
            "required": "Email or Phone or AMKA is required."
        },
        "phone": {
            "phone": "Phone",
            "placeholder": "Enter Phone Number "
        },
        "gemh": {
            "gemh": "GEMH no",
            "placeholder": "Enter gemhNo "
        },
        "webpage": {
            "webpage": "Webpage",
            "placeholder": "eg. https://www.example.com/"
        },
        "clientNotes": {
            "clientNotes": "Client Notes:",
            "placeholder": "Add Client Notes"
        },
        "representativeName": {
            "representativeName": "Representative Name",
            "placeholder": "Representative Name"
        },
        "representativeSurname": {
            "representativeSurname": "Representative Surname",
            "placeholder": "Representative Surname"
        },
        "representativeVatNumber": {
            "representativeVatNumber": "Representative Vat Number",
            "placeholder": "Representative Vat Number"
        }
    },
    "ClientsGeneralInstallations": {
        "table": {
            "type": "Type",
            "address": "Address",
            "installationDoy": "Installation DOY",
            "city": "City",
            "postalCode": "Postal Code",
            "installationVatCategory": "Installation Vat Category",
            "0VatReason": "0% Vat Reason",
            "customVat": "Custom VAT %"
        },
        "installations": "Installations:"
    },
    "ClientMovementEdit": {
        "message": "Please select Document Type first..",
        "table": {
            "clientCode": "Client Code",
            "clientName": "Client Name",
            "amount": "Amount"
        },
        "files": "Files",
        "documentTypes": "Document Types",
        "installation": "Installation",
        "preNumber": "Pre Number",
        "number": {
            "number": "Number",
            "placeholder": "Document Number"
        },
        "date": "Date",
        "reason": {
            "reason": "Reason",
            "placeholder": "Enter reason"
        },
        "sum": "Sum",
        "movementsNotes": "Movements Notes",
        "addMovementsNotes": "Add Movements Notes"
    },
    "NewClientModal": {
        "message": "Add Client",
        "message2": "Please select category first..",
        "category": "Category",
        "systemCode": {
            "systemCode": "System Code",
            "placeholder": "eg. sc-***"
        },
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required."
        },
        "email": {
            "email": "Email",
            "placeholder": "eg. example@example.com",
            "required": "Invalid email address.",
            "required2": "Email or Phone is required."
        },
        "phone": {
            "phone": "Phone",
            "placeholder": "Enter Phone Number"
        },
        "vatCategory":  {
            "vatCategory": "VAT Category",
            "required": "VAT Category is required."
        },
        "0%VatReason": {
            "0%VatReason": "0% VAT Reason",
            "required": "VAT reason is required"
        },
        "customVat": {
            "customVat": "Custom VAT %",
            "placeholder": "Custom VAT",
            "required": "Custom Vat is required."
        },
        "vatNumber": {
            "vatNumber": "VAT Number",
            "placeholder": "Do not enter anything"
        },
        "vatNumber2": {
            "vatNumber2": "VAT Number",
            "placeholder": "Add Vat Number",
            "required": "Vat Number is required."
        },
        "getDetails": "Get Details",
        "doy": {
            "doy": "DOY",
            "placeholder": "DOY is required."
        },
        "activity": {
            "activity": "Activity",
            "placeholder": "Enter Activity",
            "required": "Activity is required."
        },
        "amka": {
            "amka": "AMKA",
            "placeholder": "Enter AMKA"
        },
        "country": {
            "country": "Country",
            "required": "Country is required"
        },
        "address": {
            "address": "Address",
            "placeholder": "Enter Address",
            "required": "Address is required."
        },
        "city": {
            "city": "City",
            "placeholder": "Enter City",
            "required": "City is required."
        },
        "postalCode": {
            "postalCode": "Postal Code",
            "placeholder": "Enter Postal Code",
            "required": "Postal Code is required."
        },
        "cancel": "Cancel",
        "save": "Save"
    },
    "cashRegistersNewTabs": {
        "cashRegisters": "Cash Registers"
    },
    "cashRegistersNew": {
        "active": "Active",
        "name": {
            "name": "Name ",
            "placeholder": "Enter Name ",
            "required": "Name is required field."
        },
        "isSentToAADE": "Is sent to AADE",
        "files": "Files",
        "date": {
            "date": "Date",
            "required": "Date is required field."
        },
        "serialNumber": {
            "serialNumber": "Serial Number",
            "placeholder": "Enter Serial Number",
            "required": "Serial Number is required field."
        },
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "cashRegistersSearchTabs": {
        "cashRegisters": "Search"
    },
    "cashRegistersSearch": {
        "table": {
            "name": "Name",
            "serialNumber": "Serial Number",
            "date": "Date",
            "isSentToAade": "Is sent to AADE"
        },
        "name": "Name",
        "serialNumber": "serialNumber",
        "date": "Date",
        "sent": "Sent (Active)",
        "notSent": "Not Sent (InActive)"
    },
    "PosNewTabs": {
        "registers": "Registers"
    },
    "PosNew": {
        "active": "Active",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required field."
        },
        "isSentToAade": "Is sent to AADE",
        "files": "Files",
        "date": {
            "date": "Date",
            "required": "Date is required field."
        },
        "serialNumber" : {
            "serialNumber": "Serial Number",
            "placeholder": "Enter Serial Number",
            "required": "Serial Number is required field."
        },
        "isETameiaki" : "Is e-Tameiaki",
        "tameiakiUsername" : {
            "placeholder" : "Enter username",
            "label" : "Username",
            "required" : "Username is required"
        },
        "tameiakiPassword" : {
            "placeholder" : "Enter password",
            "label" : "Password",
            "required" : "Password is required"
        },
        "tid:" : {
            "required" : "TID is required"
        },
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "EmployeeNew": {
        "active": "Active",
        "firstName": {
            "name": "First Name",
            "placeholder": "Enter First Name",
            "required": "First Name is required."
        },
        "lastName": {
            "name": "Last Name",
            "placeholder": "Enter Last Name",
            "required": "Last Name is required."
        },
        "fatherFirstName": {
            "name": "Father's First Name",
            "placeholder": "Enter Father's First Name",
            "required": "Father's First Name is required."
        },
        "fatherLastName": {
            "name": "Father's Last Name",
            "placeholder": "Enter Father's Last Name",
            "required": "Father's Last Name is required."
        },
        "motherFirstName": {
            "name": "Mother's First Name",
            "placeholder": "Enter Mother's First Name",
            "required": "Mother's First Name is required."
        },
        "motherLastName": {
            "name": "Mother's Last Name",
            "placeholder": "Enter Mother's Last Name",
            "required": "Mother's Last Name is required."
        },
        "vatNumber": {
            "name": "Vat Number",
            "placeholder": "Enter Vat Number",
            "required": "Vat Number is required."
        },
        "amka": {
            "name": "Α.Μ.Κ.Α.",
            "placeholder": "Enter Α.Μ.Κ.Α.",
            "required": "Α.Μ.Κ.Α. is required"
        },
        "amika": {
            "name": "Α.Μ.Ι.Κ.Α.",
            "placeholder": "Enter Α.Μ.Ι.Κ.Α.",
            "required": "Α.Μ.Ι.Κ.Α. is required"
        },
        "specialty": {
            "name": "Specialty",
            "placeholder": "Enter Specialty",
            "required": "Specialty is required"
        },
        "sex": {
            "name": "Φύλο",
            "required": "Απαιτείται το Φύλο"
        },
        "birthDate": {
            "name": "Birth Date",
            "required": "Birth Date is required"
        },
        "employeeType": {
            "name": "Employee Type",
            "placeholder": "Enter Employee Type",
            "required": "Employee Type is required"
        },
        "employeeCategory": {
            "name": "Employee Category",
            "placeholder": "Enter Employee Category",
            "required": "Employee Category is required"
        },
        "installation": {
            "name": "Installation",
            "placeholder": "Enter Installation",
            "required": "Installation is required"
        },
        "employeeDate": {
            "name": "Employment Date",
            "required": "Employment Date is required"
        },
        "salary": {
            "name": "Salary",
            "required": "Salary is required"
        },
        "personalLabel": "Personal Data",
        "securityLabel": "Security Data",
        "workingLabel": "Working Data",
        "resignationDate": "Resignation Date",
        "resignationCause": "Resignation Cause"
    },
    "EmployeeSearch": {
        "filters": {
            "firstName": "First Name",
            "lastName": "Last Name",
            "employeeType": "Employee Type",
            "isActive": "Show Inactive",
            "employmentDate": "Employment Date",
            "installation": "Installation",
            "vatNumber": "Vat Number"
        },
        "columns": {
            "firstName": "First Name",
            "lastName": "Last Name",
            "employeeType": "Employee Type",
            "installation": "Installation",
            "employmentDate": "Employment Date",
            "resignationDate": "Resignation Date",
            "resignationCause": "Resignation Cause",
            "birthDate": "Birth Date",
            "vatNumber": "Vat Number",
            "AMKA": "Α.Μ.Κ.Α.",
            "AMIKA": "Α.Μ.Ι.Κ.Α.",
            "salary": "Salary"
        }
    },
    "AccountingAccountSettings": {
        "description": "Το Όνομα προτύπου είναι το Όνομα του προτύπου για τον λογιστικό λογαριασμό.\n Πατώντας πανώ σε ένα πρότυπο μπορείτε να προσθέσετε προεπιλεγμένες επιλογές για τον πίνακα MyData, τον ΦΠΑ-Καθαρή Αξία καθώς και τον υπολογαριασμό του λογαριασμού."
    },
    "AccountingRecordSettings": {
        "description": "Το Όνομα κατηγορίας είναι το Όνομα τής κατηγορίας για τον λογιστικό άρθρο.\n Πατώντας πανώ σε μια κατηγορία μπορείτε να προσθέσετε υποκατηγορίες με τις οποίες μπορείτε να προσθέσετε και να επεξεργαστείτε τις προεπιλεγμένες επιλογές και λογαριαρμούς για ένα λογιστικό άρθρο."
    },
    "AccountingAccountNew": {
        "isActive": "Active Account",
        "balance": "Account Balance:",
        "movable": "Movable",
        "transferable": "Transferable",
        "category": "Account Template",
        "accountingCode":
            {
                "name": "Accounting Code",
                "placeholder": "Enter Accounting Code",
                "required": "Accounting Code is required"
            },
        "alternativeName":{
            "name": "Alternative Name",
            "placeholder": "Enter Alternative Name"
        },
        "name": {
            "name": "Account Name",
            "placeholder": "Enter Account Name",
            "required": "Account Name is required"
        },
        "isVat": "Is VAT",
        "vatReason": "0% VAT Reason",
        "isNetValue": "Is Net Value",
        "subAccount": {
            "name": "SubAccount",
            "required": "SubAccount is mandatory"
        },
        "clientCategories": {
            "name": "Client Categories",
            "required": "The field is mandatory"
        },
        "supplierCategories": {
            "name": "Supplier Categories",
            "required": "The field is mandatory"
        },
        "employeeCategories": {
            "name": "Employee Categories",
            "required": "The field is mandatory"
        }
    },
    "AccountingAccountSearch": {
        "filters": {
            "name": "Account Name",
            "code": "Account Code",
            "alternativeName": "Account Alternative Name",
            "category": "Account Category",
            "subAccount": "Account SubAccount",
            "isActive": "Show inactive"
        },
        "columns": {
            "name": "Name",
            "code": "Code",
            "alternativeName": "Alternative Name",
            "category": "Category",
            "subAccount": "SubAccount",
            "transferable": "Transferable",
            "movable": "Movable"
        }
    },
    "PosSearchTabs": {
        "search": "Search"
    },
    "PosSearch": {
        "table": {
            "name": "Name",
            "serialNumber": "Serial Number",
            "date": "Date",
            "isSentToAade": "Is sent to AADE"
        },
        "name": "Name",
        "serialNumber": "serialNumber",
        "date": "Date",
        "sent": "Sent (Active)",
        "notSent": "Not Sent (InActive)"
    },
    "PosNewEdit": {
        "active": "Active",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required field."
        },
        "isSentToAade": "Is sent to AADE",
        "files": "Files",
        "date": {
            "date": "Date",
            "required": "Date is required field."
        },
        "serialNumber" : {
            "serialNumber": "Serial Number",
            "placeholder": "Enter Serial Number",
            "required": "Serial Number is required field."
        },
        "isETameiaki" : "Is e-Tameiaki",
        "tameiakiUsername" : {
            "placeholder" : "Enter username",
            "label" : "Username",
            "required" : "Username is required"
        },
        "tameiakiPassword" : {
            "placeholder" : "Enter password",
            "label" : "Password",
            "required" : "Password is required"
        },
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "BankAccountsNewTabs": {
        "registers": "Registers"
    },
    "BankAccountsNew": {
        "smallTable": {
            "name": "Name",
            "swift": "SWIFT",
            "country": "Country"
        },
        "active": "Active:",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required field."
        },
        "bank": {
            "bank": "Bank",
            "placeholder": "Select Template"
        },
        "files": "Files",
        "date": {
            "date": "Date",
            "required": "Date is required field."
        },
        "iban": {
            "iban": "IBAN",
            "placeholder": "Enter IBAN",
            "required": "IBAN is required field."
        },
        "isSentToAade": "Is sent to AADE",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "BankAccountsSearchTabs": {
        "search": "Search"
    },
    "BankAccountsSearch": {
        "table": {
            "name": "Name",
            "bank": "Bank",
            "iban": "IBAN",
            "date": "Date",
            "isSentToAade": "Is Sent To AADE"
        },
        "name": "Name",
        "iban": "IBAN",
        "bank": "Bank",
        "date": "Date",
        "active": "Sent (Active)",
        "inactive": "Not Sent (InActive)"
    },
    "BankAccountsNewEdit": {
        "smallTable": {
            "name": "Name",
            "swift": "SWIFT",
            "country": "Country"
        },
        "active": "Active:",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required field."
        },
        "bank": {
            "bank": "Bank",
            "placeholder": "Select Template"
        },
        "files": "Files",
        "date": {
            "date": "Date",
            "required": "Date is required field."
        },
        "iban": {
            "iban": "IBAN",
            "placeholder": "Enter IBAN",
            "required": "IBAN is required field."
        },
        "isSentToAade": "Is sent to AADE",
        "notes": "Notes",
        "addNotes": "Add Notes"
    },
    "SettingPrimerMyDataTabs": {
        "setting": "Settings"
    },
    "SettingPrimerMyData": {
        "enableSyncPrimerMyDataProvider": "Enable Sync Invoices From Primer MyData Provider",
        "enablePrimerMyDataProvider": "Enable Primer MyData Provider",
        "primerMyDataProvider": "Primer MyData Provider",
        "username": {
            "username": "Username",
            "placeholder": "Add username"
        },
        "password": {
            "password": "Password",
            "placeholder": "Add password"
        },
        "serialNumber": {
            "serialNumber": "Serial Number",
            "placeholder": "Add Serial Number"
        },
        "environment": "Environment:",
        "activate": "Activate",
        "primerMyDataInformation": "Primer MyData Information",
        "totalRemainingMyDataDocuments": "Total Remaining MyData Documents:",
        "monthlyRemainingMyDataDocuments": "Monthly Remaining MyData Documents",
        "contractActivationDate": "Contract Activation Date:",
        "contractEndDate": "Contract End Date:",
        "updateInformation": "Update Information",
        "myDataCredentials": "MyData Credentials",
        "userId": {
            "userId": "User Id",
            "placeholder": "Add User Id"
        },
        "subscriptionKey": {
            "subscriptionKey": "Subscription Key",
            "placeholder": "Add Subscription Key"
        },
        "myDataSendingMode": "MyData Sending Mode:"
    },
    "SettingsPrimerDataTabs": {
        "vat": "VAT",
        "otherTaxes1": "Other Taxes 1",
        "otherTaxes2": "Other Taxes 2",
        "otherData": "Other Data"
    },
    "SettingsPrimerData": {
        "tableZero": {
            "code": "Code",
            "description": "Description"
        },
        "tableMatching": {
            "normalVat": "Normal VAT",
            "reducedVat": "Reduced VAT",
            "zeroVat": "Zero VAT"
        },
        "table": {
            "code": "Code",
            "percentage": "Percentage",
            "accountingCode": "Accounting Code",
            "defaultValue": "Default Value",
            "deactivated": "Deactivated"
        },
        "tableWithhold": {
            "name": "Name",
            "taxLevel": "Tax Level",
            "vatIncluded": "Vat Included",
            "vatPercentage": "Vat Percentage",
            "value": "Value",
            "myData": "MyData"
        },
        "tableOtherTax": {
            "name": "Name",
            "taxLevel": "Tax Level",
            "vatIncluded": "Vat Included",
            "vatPercentage": "Vat Percentage",
            "value": "Value",
            "myData": "MyData"
        },
        "tableStamp": {
            "code": "MyData Code",
            "description": "Description",
            "taxStamp": "Tax Stamp"
        },
        "tablePaymentWay": {
            "myDataCode": "MyData Code",
            "name": "Name",
            "active": "Active"
        },
        "tableMeasurementUnits" : {
            "myDataCode": "MyData Code",
            "name": "Name",
            "shortName": "Short Name",
            "active": "Active"
        },
        "tableHours": {
            "name": "Name",
            "hours": "Hours"
        },
        "tableProductLine": {
            "myDataCode": "MyData Code",
            "name": "Name",
            "developerNotes": "Developer Notes",
            "active": "Active"
        },
        "vat%": "V. A. T. %",
        "vatMatchingTable": "V. A. T. Matching Table",
        "vat0%Reason": "Vat 0% Reason",
        "withholdTaxes": "Withhold Taxes",
        "otherTaxes": "Other Taxes",
        "feesChargesCategory": "Fees / Charges Category",
        "stamp": "Stamp",
        "paymentWays": "Payment Ways",
        "measurementUnits": "Measurement Units",
        "highlight": "Highlight",
        "allowIssuingInvoicesBefore": "Allow Issuing Invoices before:",
        "salePurpose": "Sale Purpose",
        "myDataProductLineCoding": "MyData Product Line Coding"
    },
    "DocumentTypeBasicNewTabs": {
        "basicTypes": "Basic Types",
        "basicTypesSearch": "Basic Search"
    },
    "DocumentTypeBasicNew": {
        "table": {
            "basicTypeName": "Basic Type Name",
            "typeAffectsInventory": "Type Affects Inventory",
            "typeAffectsClient": "Type Affects Client",
            "typeAffectsSupplier": "Type Affects Supplier"
        },
        "tableSearch": {
            "basicTypeNameFrom": "Basic Type Name",
            "basicTypeNameTo": "Basic Type Name To",
            "typeAffectsInventory": "Type Affects Inventory",
            "typeAffectsClient": "Type Affects Client",
            "typeAffectsSupplier": "Type Affects Supplier"
        },
        "name": {
            "name": "Name",
            "placeholder": "Enter Name"
        },
        "typeAffectsInventory": "Type Affects Inventory",
        "typeAffectsClient": "Type Affects Client",
        "typeAffectsSupplier": "Type Affects Supplier"
    },
    "DocumentTypeAdvancedNewTabs": {
        "advancedTypes": "Advanced Types",
        "advancedTypesSearch": "Advanced Types Search"
    },
    "DocumentTypeAdvancedNew": {
        "tableSmall": {
            "address": "Address",
            "city": "City",
            "type": "Type"
        },
        "table": {
            "installation": "Installation",
            "numberingMode": "Numbering Mode",
            "preNumber": "Pre-Number",
            "selected": "Selected",
            "number": "Number",
            "placeholder": "Select Installation",
            "true": "True",
            "false": "False"
        },
        "table2": {
            "automatic": "Automatic",
            "manual": "Manual"
        },
        "tableAdvanced": {
            "advancedTypeName": "Advanced Type Name",
            "basicDocumentType": "Basic Document Type",
            "section": "Section"
        },
        "tableAdvancedSearch": {
            "advancedTypeNameFrom": "Advanced Type Name",
            "advancedTypeNameTo": "Advanced Type Name To",
            "section": "Section",
            "basicDocumentType": "Basic Document Type",
            "showInactiveAdvancedTypes": "Show Inactive Advanced Types"
        },
        "message": "Please make a selection on the section first.",
        "section": "Section",
        "basicDocumentType": {
            "basicDocumentType": "Basic Document Type",
            "required": "Basic Document Type is required."
        },
        "active": "Active",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required.",
            "warning": "Name already exists."
        },
        "printTemplate": "Print Template",
        "alwaysPrintAfterSave": "Always Print After Save",
        "alwaysSendEmailAfterSave": "Always Send Email After Save",
        "useLogo": "Use Logo in print templates",
        "isCensus": "Enable census invoice",
        "canBePaidOff": "Can be paid off through client payments",
        "enableMyDataProvider": "Enable MyData Provider",
        "handwrittenDocument": "Enable Handwritten document issuance/failure to connect",
        "enableMyData": "Enable MyData",
        "enableMyDataRules": "Enable MyData Rules",
        "myDataInvoiceType": {
            "myDataInvoiceType": "MyData (Invoice) Type",
            "required": "MyData Type is required."
        },
        "creditDocument": "Credit Document",
        "creditDocumentPreNumber": "Credit Document Pre Number",
        "conversionDocument": "Conversion Document",
        "conversionDocumentPreNumber": "Conversion Document Pre Number",
        "proposedSalePurpose": "Proposed Sale Purpose",
        "thirdPartySales": "Third party sales",
        "myDataType": "MyData Type",
        "proposedPaymentType": {
            "proposedPaymentType": "Proposed Payment Type",
            "required": "Proposed Payment Type is required."
        },
        "proposedPOSBankAccount": {
            "proposedPOSBankAccount": "Proposed POS/Bank Account",
            "required": "Proposed Payment Type is required."
        },
        "documentNumbering": "Document Numbering",
        "message2": "Document Numbering should not be empty.",
        "enableDisplayClientBalance": "Display previous-new client balance on the invoice"
    },
    "DocumentTypeAdvancedNewEdit": {
        "tableSmall": {
            "address": "Address",
            "city": "City",
            "type": "Type"
        },
        "table": {
            "installation": "Installation",
            "numberingMode": "Numbering Mode",
            "preNumber": "Pre-Number",
            "selected": "Selected",
            "number": "Number"
        },
        "tableAdvanced": {
            "advancedTypeName": "Advanced Type Name",
            "basicDocumentType": "Basic Document Type",
            "section": "Section"
        },
        "tableAdvancedSearch": {
            "advancedTypeNameFrom": "Advanced Type Name From",
            "advancedTypeNameTo": "Advanced Type Name To",
            "section": "Section",
            "basicDocumentType": "Basic Document Type",
            "showInactiveAdvancedTypes": "Show Inactive Advanced Types"
        },
        "message": "Please make a selection on the section first.",
        "section": "Section",
        "basicDocumentType": {
            "basicDocumentType": "Basic Document Type",
            "required": "Basic Document Type is required."
        },
        "active": "Active",
        "name": {
            "name": "Name",
            "placeholder": "Enter Name",
            "required": "Name is required.",
            "warning": "Name already exists."
        },
        "printTemplate": "Print Template",
        "alwaysPrintAfterSave": "Always Print After Save",
        "alwaysSendEmailAfterSave": "Always Send Email After Save",
        "enableMyDataProvider": "Enable MyData Provider",
        "handwrittenDocument": "Enable Handwritten document issuance/failure to connect",
        "enableMyData": "Enable MyData",
        "enableMyDataRules": "Enable MyData Rules",
        "myDataInvoiceType": {
            "myDataInvoiceType": "MyData Type",
            "required": "MyData Type is required."
        },
        "creditDocument": "Credit Document",
        "creditDocumentPreNumber": "Credit Document Pre Number",
        "conversionDocument": "Conversion Document",
        "conversionDocumentPreNumber": "Conversion Document Pre Number",
        "proposedSalePurpose": "Proposed Sale Purpose",
        "thirdPartySales": "Third party sales",
        "myDataType": "MyData Type",
        "proposedPaymentType": {
            "proposedPaymentType": "Proposed Payment Type",
            "required": "Proposed Payment Type is required."
        },
        "proposedPOSBankAccount": {
            "proposedPOSBankAccount": "Proposed POS/Bank Account",
            "required": "Proposed Payment Type is required."
        },
        "documentNumbering": "Document Numbering",
        "message2": "Document Numbering should not be empty.",
        "enableDisplayClientBalance": "Display previous-new client balance on the invoice"
    },
    "GeneralSettingsTabs": {
        "companySettings": "Company Settings",
        "tasks": "Tasks"
    },
    "GeneralSettings":{
        "tableClientInstallations": {
            "type": "Type",
            "address": "Address",
            "doy": "DOY",
            "city": "City",
            "postalCode": "Postal Code"
        },
        "tableCompanyUser": {
            "firstName": "First Name",
            "lastName": "Last Name",
            "email": "Email",
            "userRights": "User Type",
            "username": "Username"
        },
        "licensedTo": "Licensed to",
        "companyName": {
            "companyName": "Company Name:",
            "placeholder": "Empty"
        },
        "companySmallName": {
            "companySmallName": "Company Small Name:",
            "placeholder": "Empty"
        },
        "activity": {
            "activity": "Activity:",
            "placeholder": "Empty"
        },
        "vatNumber": {
            "vatNumber": "VAT number:",
            "placeholder": "Empty"
        },
        "headquartersAddress": {
            "headquartersAddress": "Headquarters Address:",
            "placeholder": "Empty"
        },
        "city": {
            "city": "City:",
            "placeholder": "Empty"
        },
        "country": {
            "country": "Country:",
            "placeholder": "Empty"
        },
        "postalCode": {
            "postalCode": "Postal Code:",
            "placeholder": "Empty"
        },
        "phoneNumber": {
            "phoneNumber": "Phone number:",
            "placeholder": "Empty"
        },
        "email": {
            "email": "Email address:",
            "placeholder": "Empty"
        },
        "gemh": {
            "gemh": "GEMH Number:",
            "placeholder": "Empty"
        },
        "representativeName": {
            "representativeName": "Representative Name:",
            "placeholder": "Empty"
        },
        "representativeSurname": {
            "representativeSurname": "Representative Surname:",
            "placeholder": "Empty"
        },
        "representativeVatNumber": {
            "representativeVatNumber": "Representative Vat Number:",
            "placeholder": "Empty"
        },
        "companyStartDate": "Company Start Date: ",
        "companyExpireDate": "Company Expire Date: ",
        "companyLogo": "Company Logo:",
        "uploadFile": "Upload File",
        "uploadFileDesc": "JPG, PNG only with dimensions 350 x 100px.",
        "useLogoInInvoices": "Use Logo in invoices",
        "finished": "Finished",
        "installations": "Installations",
        "companyUsers": "Company Users"
    },
    "SettingsSystemTasks": {
        "reUpdateProductsInventoryBalance": "Reupdate Products inventory balance",
        "reUpdateClientBalance": "Reupdate Clients Balance",
        "reUpdateSupplierBalance": "Reupdate Suppliers Balance",
        "reUpdateClientInfo": "Reupdate Clients Information",
        "reUpdateSupplierInfo": "Reupdate Suppliers Information",
        "syncClientPaymentsWithSales" : "Synchronize Client Payments with Sales",
        "reupdate": "Reupdate",
        "sync": "Synchronize",
        "warning": "Warning!!",
        "message": "All product inventory balances will be re calculated. The process can\n only be used once per 60 minutes. All users logged in will be logged\n out until the process is completed. Continue?",
        "clientMessage": "All client balances will be re calculated. The process can\n only be used once per 60 minutes. All users logged in will be logged\n out until the process is completed. Continue?",
        "supplierMessage": "All supplier balances will be re calculated. The process can\n only be used once per 60 minutes. All users logged in will be logged\n out until the process is completed. Continue?",
        "clientUpdateMessage": "All client data will be re fetched. All users logged in will be logged\n out until the process is completed. Continue?",
        "clientUpdateCompletedMessage1": "Clients update completed.",
        "clientUpdateCompletedMessage2": "Total clients:",
        "clientUpdateCompletedMessage3": "Updated:",
        "supplierUpdateMessage": "All supplier data will be re fetched. All users logged in will be logged\n out until the process is completed. Continue?",
        "supplierUpdateCompletedMessage1": "Suplliers update completed.",
        "supplierUpdateCompletedMessage2": "Total suppliers:",
        "supplierUpdateCompletedMessage3": "Updated:",
        "syncMessage": "Every sale is going to be synchronized with client payments. All users logged in will be logged out until the process is completed. Continue?",
        "no": "No",
        "yes": "Yes"
    },
    "SettingsEmailSMTP": {
        "usePrimerSmtp": "Use Primer Smtp",
        "useCustomSmtp": "Use Custom Smtp",
        "smtpSettings": "Smtp Settings",
        "fromEmail": {
            "fromEmail": "From Email",
            "placeholder": "Add From Email"
        },
        "username": {
            "username": "Username",
            "placeholder": "Add Username"
        },
        "password": {
            "password": "Password",
            "placeholder": "Add Password"
        },
        "encryptionType": "Encryption Type",
        "none": "None",
        "start": "Start",
        "message": "For most servers SSL/TLS is the recommended option",
        "no": "No",
        "yes": "Yes",
        "smtpAuthentication": "SMTP Authentication",
        "smtpServerPlaceholder": "Add SMTP Server",
        "smtpPort": "SMTP Port",
        "smtpPortPlaceholder": "Add SMTP Port",
        "emailSettings": "Email Settings",
        "correspondentName": {
            "correspondentName": "Correspondent Name",
            "required": "Add Correspondent Name"
        },
        "mailSubject": {
            "mailSubject": "Mail Subject",
            "placeholder": "Add Mail Subject"
        },
        "addWildcard": "Add Wildcard",
        "wildcards": "Wildcards -",
        "message2": "Click on wildcard to add in the Mail Subject.",
        "testSMTPConnection": "Test SMTP Connection"
    },
    "SettingsImportExport": {
        "section" : "Section",
        "sectionProducts" : "Products",
        "sectionProductMovements": "Product Movements",
        "sectionClients" : "Clients",
        "sectionClientPayments" : "Client Payments",
        "sectionClientMovements" : "Client Movements",
        "sectionSupplierMovements" : "Supplier Movements",
        "sectionSales" : "Sales",
        "sectionPOS" : "POS",
        "sectionCashRegisters" : "Cash Registers",
        "sectionBankAccounts" : "Bank Accounts",
        "sectionSuppliers" : "Suppliers",
        "sectionEmployees" : "Employees",
        "sectionAccountingAccounts" : "Accounting Accounts",
        "sectionAccountingRecords" : "Accounting Records",
        "sectionFixedAssets": "Fixed Assets",
        "sectionFixedAssetMovements": "Fixed Asset Movements",
        "help" : "Help",
        "no" : "No",
        "fieldName" : "Field Name",
        "excelColumn" : "Excel Columns",
        "mandatoryFields" : "Fields marked with * are mandatory",
        "results" : "Results",
        "startImport" : "Start Import",
        "startExport" : "Start Export",
        "autocomplete": "Auto Complete Columns",
        "Products" : {
            "name" : "Product Name",
            "alternativeName" : "Alternative Name",
            "category" : "Category",
            "alternativeCode" : "Alternative Code",
            "barCode" : "Barcode",
            "vat" : "VAT",
            "measurementUnit" : "Measurement Unit",
            "vatReason" : "0% VAT Reason",
            "price" : "Price",
            "buyPrice" : "Buy Price",
            "vatIncluded" : "VAT Included",
            "vatIncludedBuy" : "VAT Included For Buy",
            "productNotes" : "Product Notes",
            "feeTax" : "Fee Tax",
            "otherTax" : "Other Tax",
            "withholdTax" : "Withhold Tax",
            "stampDutyTax" : "Stamp Duty Tax",
            "myDataIncExp" : "MyData Income/Expense",
            "myDataRowType" : "MyData Row Type",
            "myDataRowCategory" : "MyData Row Category",
            "myDataRowInvoiceType" : "MyData Row Invoice Type",
            "myDataRowVatExpenseType": "My Data Vat Expense Type",
            "accountingCode": "Accounting Code Prefix",
            "netAmountAccountingCode": "Net Amount Accounting Code Override",
            "vatAccountingCode": "Vat Accounting Code Override",
            "taxAccountCode": "Tax Account Code Override",
            "accountingNonDeductibleVAT": "Accounting Non Deductible VAT",
            "accountingCodeSales": "Accounting Code Prefix for Sales",
            "netAmountAccountingCodeSales": "Net Amount Accounting Code Override for Sales",
            "vatAccountingCodeSales": "Vat Account Code Override for Sales",
            "taxAccountCodeSales": "Tax Account Code Override for Sales",
            "accountingCodeBuys": "Accounting Code Prefix for Buys",
            "netAmountAccountingCodeBuys": "Net Amount Accounting Code Override for Buys",
            "vatAccountingCodeBuys": "Vat Account Code Override for Buys",
            "taxAccountCodeBuys": "Tax Account Code Override for Buys",
            "cpvCode": "CPV Code",
            "showAlternativeNameOnPrint": "Show alternative name on print layouts",
            "showAlternativeCodeOnPrint": "Show alternative code on print layouts"
        },
        "Clients" : {
            "name" : "Client Name",
            "smallName" : "Client Small Name",
            "manualCode" : "Manual Code",
            "category" : "Category",
            "vatNumber" : "VAT Number",
            "vatCategory" : "VAT Category",
            "vatReason" : "VAT Reason",
            "country" : "Country",
            "city" : "City",
            "address" : "Address",
            "postalCode" : "Postal Code",
            "DOY" : "DOY",
            "activity" : "Activity",
            "GEMH" : "GEMH",
            "webpage" : "Webpage",
            "email" : "Email",
            "phone" : "Phone",
            "amka" : "AMKA",
            "clientNotes" : "Notes",
            "contactName" : "Contact Name",
            "contactPhone" : "Contact Phone",
            "contactPhone2" : "Contact Phone 2",
            "contactLandline" : "Contact Landline",
            "contactEmail" : "Contact Email",
            "contactNotes" : "Contact Notes",
            "contactAcceptNotifications" : "Contact Accepts Notifications",
            "installationNo" : "Installation No",
            "installationAddress" : "Installation Address",
            "installationDOY" : "Installation DOY",
            "installationCity" : "Installation City",
            "installationPostalCode" : "Installation Postal Code",
            "installationVatCategory" : "Installation VAT Category",
            "installationVatReason" : "Installation VAT Reason",
            "installationCustomVat" : "Installation Custom VAT",
            "accounting": "Accounting Bridge Prefix",
            "bypassAccounting": "Accounting Bridge Bypass Code"
        },
        "Client Movements" : {
            "documentTypeName" : "Document Type Name",
            "installationMasterID" : "Installation Master ID",
            "serialNumber" : "Serial Number",
            "number" : "Number",
            "date" : "Date",
            "reason" : "Reason",
            "clientVATNumber" : "Client VAT Number",
            "clientMovementAmount" : "Client Movement Amount",
            "notes" : "Notes",
            "clientPhone" : "Client Phone",
            "clientEmail" : "Client Email",
            "clientAMKA" : "Client AMKA"
        },
        "Supplier Movements" : {
            "documentTypeName" : "Document Type Name",
            "installationMasterID" : "Installation Master ID",
            "serialNumber" : "Serial Number",
            "number" : "Number",
            "date" : "Date",
            "reason" : "Reason",
            "supplierVATNumber" : "Supplier VAT Number",
            "supplierMovementAmount" : "Supplier Movement Amount",
            "notes" : "Notes",
            "supplierPhone" : "Supplier Phone",
            "supplierEmail" : "Supplier Email",
            "supplierAMKA" : "Supplier AMKA"
        },
        "Client Payments" : {
            "documentTypeName" : "Document Type Name",
            "installation" : "Installation Master ID",
            "serialNumber" : "Serial Number",
            "number" : "Number",
            "vatNumber" : "VAT Number",
            "paymentDate" : "Payment Date",
            "paymentReason" : "Payment Reason",
            "paymentNotes" : "Payment Notes",
            "paymentType" : "Payment Type",
            "bankNumber" : "Bank Number",
            "posSerial" : "POS Serial",
            "amount" : "Amount",
            "chequeFirstDate" : "Cheque First Date",
            "chequeLastDate" : "Cheque Last Date",
            "clientPhone" : "Client Phone",
            "clientEmail" : "Client Email",
            "clientAMKA" : "Client AMKA",
            "clientName": "Client Name"
        },
        "Sales" : {
            "documentTypeName" : "Document Type Name",
            "date" : "Sale Date",
            "time" : "Time",
            "installationMasterID" : "Installation Master ID",
            "serialNumber" : "Serial Number",
            "number" : "Number",
            "clientVATNumber" : "Client VAT Number",
            "clientPhone" : "Client Phone",
            "clientEmail" : "Client Email",
            "clientAMKA" : "Client AMKA",
            "clientInstallation" : "Client Installation Master ID",
            "paymentType" : "Payment Type",
            "bankNumber" : "Bank Number",
            "posSerial" : "POS Serial",
            "productName" : "Product Name",
            "quantity" : "Quantity",
            "unitPrice" : "Unit Price",
            "discount" : "Discount",
            "netValue" : "Net Value",
            "vat" : "VAT Value",
            "vatPercentage" : "VAT Percentage",
            "vatReason" : "0% VAT Reason",
            "totalValue" : "Total Value",
            "isTaxLine" : "Is Tax Line",
            "productExtraTaxType" : "Product Extra Tax Type",
            "productExtraTaxCode" : "Product Extra Tax Code",
            "productExtraTaxAmount" : "Product Extra Tax Amount",
            "deliveryLocation" : "Delivery Location",
            "deliveryLocationAddress" : "Delivery Location Address",
            "deliveryLocationCity" : "Delivery Location City",
            "deliveryLocationCountry" : "Delivery Location Country",
            "deliveryLocationPostalCode" : "Delivery Location Postal Code",
            "myDataUID" : "My Data UID",
            "myDataMark" : "My Data Mark",
            "myDataAuthCode" : "My Data Auth Code",
            "extraDataTaxType" : "Extra Data Tax Type",
            "extraDataTaxCode" : "Extra Data Tax Code",
            "extraDataTaxAmount" : "Extra Data Tax Amount",
            "mutedBasicData" : "Basic Invoice Data",
            "mutedBasicDataLine" : "Line Invoice Data",
            "mutedMyData" : "My Data",
            "mutedExtraData" : "Extra Data - Other Taxes",
            "wayOfSendingGoods" : "Way of sending goods",
            "carNumber" : "Car number",
            "salePurpose": "Σκοπός Διακίνησης",
            "otherCorrelatedEntitiesTypes": "Other Correlated Entity Types",
            "otherCorrelatedEntitiesVatNumbers": "Other Correlated Entity VAT Numbers"
        },
        "Employees": {
            firstName: "First Name",
            lastName: "Last Name",
            sex: "Sex",
            birthDate: "Birth Date",
            vatNumber: "VAT Number",
            fatherFirstName: "Father First Name",
            fatherLastName: "Father Last Name",
            motherFirstName: "Mother First Name",
            motherLastName: "Mother Last Name",
            phone: "Phone",
            email: "E-Mail",
            amka: "AMKA",
            amika: "AMIKA",
            ama: "AMA",
            employeeCategory: "Employee Category",
            employeeType: "Employee Type",
            specialty: "Specialty",
            installation: "Installation",
            workingDaysPerWeek: "Working Days Per Week",
            workingHoursPerWeek: "Working Hours Per Week",
            symbatikesWorkingHoursPerWeek: "Contractual Working Hours Per Week",
            workingExperienceYears: "Working Experience Years",
            firstYearPermits: "First Year Permits",
            breakMinutes: "Break Minutes",
            breakMinutesWhen: "Break Type",
            kathestos: "Employment Status",
            employmentDate: "Employment Date",
            salary: "Salary",
            erganiCard: "Ergani Card",
            flexibleAttendanceMinutes: "Flexible Attendance Minutes",
            resignationDate: "Resignation Date",
            resignationCause: "Resignation Cause",
            notes: "Notes",
        },
        "POS" : {
            "name" : "Name",
            "date" : "Date",
            "serialNumber" : "Serial Number",
            "sendToAADE" : "Send to AADE",
            "notes" : "Notes"
        },
        "Cash Registers" : {
            "name" : "Name",
            "date" : "Date",
            "serialNumber" : "Serial Number",
            "sendToAADE" : "Send to AADE",
            "notes" : "Notes"
        },
        "Bank Accounts" : {
            "name" : "Name",
            "bankSwift" : "Bank Swift",
            "date" : "Date",
            "iban" : "IBAN",
            "sendToAADE" : "Send to AADE",
            "notes" : "Notes"
        },
        "Suppliers" : {
            "name" : "Supplier Name",
            "smallName" : "Supplier Small Name",
            "manualCode" : "Manual Code",
            "category" : "Category",
            "vatNumber" : "VAT Number",
            "vatCategory" : "VAT Category",
            "vatReason" : "VAT Reason",
            "country" : "Country",
            "city" : "City",
            "address" : "Address",
            "postalCode" : "Postal Code",
            "DOY" : "DOY",
            "activity" : "Activity",
            "GEMH" : "GEMH",
            "webpage" : "Webpage",
            "email" : "Email",
            "phone" : "Phone",
            "amka" : "AMKA",
            "notes" : "Notes",
            "contactName" : "Contact Name",
            "contactPhone" : "Contact Phone",
            "contactPhone2" : "Contact Phone 2",
            "contactLandline" : "Contact Landline",
            "contactEmail" : "Contact Email",
            "contactNotes" : "Contact Notes",
            "contactAcceptNotifications" : "Contact Accepts Notifications",
            "installationNo" : "Installation No",
            "installationAddress" : "Installation Address",
            "installationDOY" : "Installation DOY",
            "installationCity" : "Installation City",
            "installationPostalCode" : "Installation Postal Code",
            "installationVatCategory" : "Installation VAT Category",
            "installationVatReason" : "Installation VAT Reason",
            "installationCustomVat" : "Installation Custom VAT",
            "accounting": "Accounting Bridge Prefix",
            "bypassAccounting": "Accounting Bridge Bypass Code"
        },
        "Accounting Accounts" : {
            "category" : "Accounting Category",
            "code" : "Account Code",
            "name" : "Account Name",
            "alternativeName" : "Alternative Name",
            "movable" : "Movable",
            "transferable" : "Transferable",
            "isNetValue" : "Net Value %",
            "vat" : "VAT %",
            "taxType" : "Is tax",
            "subAccount" : "Sub Account",
            "mutedCaseTax" : "In case that is tax",
            "fee" : "Fee code",
            "stamp" : "Stamp Duty Tax code",
            "withHoldTax" : "Withhold tax code",
            "otherTax" : "Other tax code"
        },
        "Product Movements": {
            "documentTypeName": "Document Type",
            "installationMasterID": "Installation ID",
            "preNumber": "Pre number",
            "number": "Number",
            "date": "Date",
            "reason": "Reason",
            "productName": "Product Name",
            "productUnitPrice": "Product Unit Price",
            "productQuantity": "Product Quantity",
            "notes": "Notes"
        },
        "Fixed Assets": {
            "category": "Category",
            "name": "Name",
            "quantity": "Quantity",
            "date": "Date acquired",
            "manualCode": "Manual Code",
            "acquisitionCost": "Acquisition Cost",
            "percentage": "Yearly depreciation %",
            "accounting": "Accounting Bridge Prefix",
            "bypassAccounting": "Accounting Bridge Bypass Account",
            "installation": "Installation Number",
            "inverseAccounting": "Inverse Accounting Bridge Prefix",
            "bypassInverseAccounting": "Accounting Bridge Bypass Inverse Account",
            "accountingCodeSales": "Accounting Code Prefix for Sales",
            "netAmountAccountingCodeSales": "Net Amount Accounting Code Override for Sales",
            "vatAccountingCodeSales": "Vat Account Code Override for Sales",
            "taxAccountCodeSales": "Tax Account Code Override for Sales",
            "accountingCodeBuys": "Accounting Code Prefix for Buys",
            "netAmountAccountingCodeBuys": "Net Amount Accounting Code Override for Buys",
            "vatAccountingCodeBuys": "Vat Account Code Override for Buys",
            "taxAccountCodeBuys": "Tax Account Code Override for Buys"
        },
        "Fixed Asset Movements": {
            "documentTypeName": "Document Type",
            "date": "Date",
            "installation": "Installation Number",
            "preNumber": "Pre Number",
            "number": "Number",
            "reason": "Reason",
            "fixedAsset": "Fixed Asset Name",
            "amount": "Depreciation Amount",
            "notes": "Notes"
        },
        "Accounting Records": {
            "categoryName": "Category",
            "subCategoryName": "Subcategory",
            "documentTypeName": "Document Type",
            "date": "Date",
            "time": "Time",
            "installation": "installation",
            "preNumber": "Series",
            "number": "Number",
            "reason": "Reason",
            "paymentTypeName": "Payment Type",
            "accountCode": "Accounting Code",
            "subAccount": "Sub Account",
            "debit": "Debit",
            "credit": "Credit"
        },
        "chooseFile" : "Choose File",
        "firstLine" : "First Line",
        "insertNewRecords" : "Insert New Records",
        "updateExistingRecords" : "Update Existing Records",
        "back" : "Back",
        "checkData" : "Check Data",
        "insertData" : "Insert Data",
        "textInstead" : "Text instead of id values (*)",
        "textOnlyDanger" : "(*) Exported XLSX with text instead of values will not be importable by the system. Can only be used for personal use.",
        "export" : "Export",
        "joyride" : {
            "back" : "Back",
            "close" : "Close",
            "last" : "Last",
            "next" : "Next",
            "open" : "Open",
            "skip" : "Skip",
            "section" : "This is the section dropdown. Select a section you want to import.",
            "fields" : "These are the fields. Fields with RED * are required!",
            "columns" : "These are the columns. Select the column that matches your excel file.",
            "tooltips" : "Button like this pop a tooltip, helping you understand the data you need to enter in order not to have errors.",
            "file" : "Select the file you want to upload.",
            "firstLine" : "Enter the first line that your data starts.",
            "insertNew" : "Check this checkbox if you want to insert new entries in the database.",
            "updateExisting" : "Check this checkbox if you want to update the entries in the database.",
            "checkData" : "In order to insert or update you first need to check your data.",
            "insertData" : "If you have at least one valid entry, this button will get enabled.",
            "columnsExport" : "These are the columns. Select the column that will be written in the excel file.",
            "tooltipsExport" : "Button like this pop a tooltip, helping you understand the data type that will be exported to your excel columns.",
            "textInstead" : "Checking this checkbox will export the data to a format that is easy to read for an user, thus not importable again by the system.",
            "exportButton" : "Clicking this button will export the file in XLSX format. It will be downloaded to your computer.",
            "backButton" : "Click this button if you want to go back anytime and add/remove fields."
        },
        "toasts" : {
            "alreadySelectedColumn" : "This excel column is already exist in another field",
            "pleaseSelectColumnFor" : "Please Select the excel Column value for",
            "someExcelColumnsAreEmpty" : "Some excel columns are empty",
            "pleaseSelectAFileFirst" : "Please select file first",
            "onlyXLSXValid" : "Only XLS or XLSX files are valid",
            "firstLineIsEmpty" : "First line must not be empty",
            "pleaseCheckData" : "Please check data first",
            "atLeastOneCheckbox": "One of the checkboxes must be checked",
            "selectionEmpty" : "Please select section in settings tab first",
            "myDataCheck" : "You need to have My Data Mark and UID checked in order to enable auth code.",
            "deliveryLocationCheck" : "You need to have Delivery Location in order to enable."
        }
    },
    "SettingsBackup" : {
        "buttonBackup" : "Create Backup",
        "buttonCompanyTemplate" : "Export company template",
        "creatingBackup" : "Creating backup...",
        "creatingBackupToast" : "Creating backup, please wait.",
        "backupCreated" : "Backup created.",
        "backupCreatedToast" : "Backup created.",
        "creatingCompanyTemplate" : "Creating company template...",
        "creatingCompanyTemplateToast" : "Creating company template, please wait.",
        "companyTemplateCreated" : "Company template created.",
        "companyTemplateCreatedToast" : "Company template created."
    },
    "SettingsRestore" : {
        "restoring" : "Restoring...",
        "pleaseSelectFile" : "Please select a file first!",
        "onlyJSONFiles" : "Only JSON files are allowed!",
        "restorationComplete" : "Restoration complete.",
        "restorationFailed" : "Restoration failed!",
        "warningMessage" : "Only restore backups made from the same company! Restoring a backup from another company, will break the functionality on both. Restoration of company template doesn't need to be from the same company.",
        "warningMessage2" : "Be careful the type of file you restore. If you restore backup, press the restore backup button, else the restore company template button. Both restoration processes, delete all the data.",
        "buttonRestoreBackup" : "Restore Backup",
        "buttonRestoreCompanyTemplate" : "Restore Company Template"
    },
    "basicModal" : {
        "close" : "Close",
        "ok" : "OK"
    },
    "searchSideTable": {
        "cancel": "Cancel",
        "save": "Save",
        "currentValue": "Current Value:",
        "sent": "Sent (Active)",
        "notSent": "Not Sent (InActive)",
        "enterNew": "Enter New"
    },
    "ClosingTabWarning": {
        "warning": "Warning!",
        "message": "Warning: Not saved data are going to be lost,do you want to continue?",
        "no": "No",
        "yes": "Yes"
    },
    "dateFilterColumn": {
        "thisMonth": "This Month",
        "lastMonth": "Last Month",
        "thisYear": "This Year",
        "custom": "Custom",
        "noRecordsFound": "No records found.",
        "filter": "Filter..."
    },
    "insertPlaceholders": {
        "insert": "Insert",
        "insertCategory": "Insert Category",
        "insertCodeMask": "Insert Code Mask",
        "insertName": "Insert Name",
        "add": "Add ",
        "select": "Select...",
        "required": "Required."
    },
    "AdvanceTypesNewDropDown": {
        "null": "Null/Blank",
        "productMovements": "Product Movements",
        "sales": "Sales",
        "clientMovements": "Client Movements",
        "clientPayments": "Client Payments",
        "buys": "Buys",
        "supplierPayments": "Supplier Payments",
        "accountingRecords": "Accounting Records",
        "fixedAssetRecords": "Fixed Asset Records",
        "fixedAssetMovements": "Fixed Asset Movements"
    },
    "EmployeeTabs": {
        "New": "General",
        "Edit": "General",
        "Search": "Search"
    },
    "AccountingAccountTabs": {
        "New": "General",
        "NewMyData" : "MyData",
        "EditMyData" : "MyData",
        "Edit": "General",
        "Search": "Search"
    },
    "AccountingRecordTabs": {
        "New": "General",
        "Commercial" : "Commercial Record",
        "Edit": "General",
        "Search": "Search"
    },
    "Logs": {
        "product_create": "Product Create",
        "product_update": "Product Update",
        "product_delete": "Product Delete",
        "productMovement_create": "Product Movement Create",
        "productMovement_update": "Product Movement Update",
        "productMovement_delete": "Product Movement Delete",
        "productPrice_create": "Price List Create",
        "productPrice_update": "Price List Update",
        "productPrice_delete": "Price List Delete",
        "sale_create": "Sale Create",
        "sale_update": "Sale Update",
        "sale_delete": "Sale Delete",
        "sale_sendMyData": "Sale myData",
        "sale_sendMyDataProvider": "Sale myData (provider)",
        "buy_create": "Buy Create",
        "buy_update": "Buy Update",
        "buy_delete": "Buy Delete",
        "buy_sendMyData": "Buy myData",
        "client_create": "Client Create",
        "client_update": "Client Update",
        "client_delete": "Client Delete",
        "clientPayment_create": "Client Payment Create",
        "clientPayment_update": "Client Payment Update",
        "clientPayment_delete": "Client Payment Delete",
        "clientMovement_create": "Client Movement Create",
        "clientMovement_update": "Client Movement Update",
        "clientMovement_delete": "Client Movement Delete",
        "supplier_create": "Supplier Create",
        "supplier_update": "Supplier Update",
        "supplier_delete": "Supplier Delete",
        "supplierPayment_create": "Supplier Payment Create",
        "supplierPayment_update": "Supplier Payment Update",
        "supplierPayment_delete": "Supplier Payment Delete",
        "supplierMovement_create": "Supplier Movement Create",
        "supplierMovement_update": "Supplier Movement Update",
        "supplierMovement_delete": "Supplier Movement Delete",
        "employee_create": "Employee Create",
        "employee_update": "Employee Update",
        "employee_delete": "Employee Delete",
        "workPermit_create": "Work Permit Create",
        "workPermit_update": "Work Permit Update",
        "workPermit_delete": "Work Permit Delete",
        "workMovement_create": "Work Movement Create",
        "workMovement_update": "Work Movement Update",
        "workMovement_delete": "Work Movement Delete",
        "cash_create": "Cash Create",
        "cash_update": "Cash Update",
        "cash_delete": "Cash Delete",
        "bank_create": "Bank Create",
        "bank_update": "Bank Update",
        "bank_delete": "Bank Delete",
        "pos_create": "POS Create",
        "pos_update": "POS Update",
        "pos_delete": "POS Delete",
        "account_create": "Account Create",
        "account_update": "Account Update",
        "account_delete": "Account Delete",
        "record_create": "Record Create",
        "record_update": "Record Update",
        "record_delete": "Record Delete",
        "basicSetting_create": "Basic Document Create",
        "basicSetting_update": "Basic Document Update",
        "basicSetting_delete": "Basic Document Delete",
        "advancedSetting_create": "Advanced Document Create",
        "advancedSetting_update": "Advanced Document Update",
        "advancedSetting_delete": "Advanced Document Delete",
        "productCategory_create": "Product Category Create",
        "productCategory_update": "Product Category Update",
        "productCategory_delete": "Product Category Delete",
        "quickRetailSalesSetting_update": "Quick Retail Settings Update",
        "clientSetting_create": "Client Settings Create",
        "clientSetting_update": "Client Settings Update",
        "supplierSetting_create": "Supplier Settings Create",
        "supplierSetting_update": "Supplier Settings Update",
        "cashSetting_create": "Cash Settings Create",
        "cashSetting_update": "Cash Settings Update",
        "salesSetting_update": "Sales Settings Update",
        "buysSetting_update": "Buys Settings Update",
        "accountingSetting_create": "Accounting Settings Create",
        "accountingSetting_update": "Accounting Settings Update",
        "payrollSetting_update": "Ενημέρωση Ρυθμίσεων Μισθοδοσίας",
        "file_export": "File Export",
        "dcl_create": "Create Digital Client Document",
        "dcl_update": "Edit Digital Client Document",
        "cancel_dcl": "Cancel Digital Client Document",
        "fixed_asset_create": "Create a fixed asset",
        "fixed_asset_update": "Update a fixed asset",
        "fixed_asset_delete": "Delete a fixed asset",
        "fixed_asset_movement_create": "Create a fixed asset movement",
        "fixed_asset_movement_update": "Update a fixed asset movement",
        "fixed_asset_movement_delete": "Delete a fixed asset movement",
        "fixed_asset_record_create": "Create a fixed asset record",
        "fixed_asset_record_update": "Update a fixed asset record",
        "fixed_asset_record_delete": "Delete a fixed asset record",
        "cancel_document": "When a document is cancelled",
        "ai_register": "Register Document with Primer AI",
        "ai_reprocess": "Sent for reprocessing to Primer AI",
        "ai_decline": "Decline AI document",
        "yes": "Yes",
        "no": "No",
        "name": "Name",
        "alternateName": "Alternative Name",
        "code": "Code",
        "alternateCode": "Alternative Code",
        "vat": "Vat%",
        "price": "Preferred Price",
        "vatIncluded": "Vat Included",
        "measurementUnit": "Measurement Unit",
        "categoryName": "Category",
        "isActive": "Active",
        "showAlternativeNameOnPrint": "Alternative Name On Print",
        "showAlternativeCodeOnPrint": "Alternative Code On Print",
        "cpvCode": "CPV Code",
        "clientLog": "Client Log",
        "clientsLog": "Clients Log",
        "supplierLog": "Supplier log",
        "suppliersLog": "Suppliers Log",
        "employeeLog": "Employee Log",
        "employeesLog": "Employees Log",
        "workPermitLog": "Work Permit Log",
        "workPermitsLog": "Work Permits Log",
        "workMovementLog": "Work Movement Log",
        "workMovementsLog": "Work Movements Log",
        "payrollSettingsLog": "Payroll Settings Log",
        "priceListLog": "Price list log",
        "productLog": "Product Log",
        "productsLog": "Products log",
        "productMovementLog": "Product Movement Log",
        "productMovementsLog": "Product Movements Log",
        "clientMovementLog": "Client Movement Log",
        "clientMovementsLog": "Client Movements Log",
        "supplierMovementLog": "Supplier Movement Log",
        "supplierMovementsLog": "Supplier Movements Log",
        "salesLog": "Sales Log",
        "buyLog": "Buy Log",
        "buysLog": "Buys Log",
        "posLog": "POS Log",
        "bankAccountLog": "Bank Account Log",
        "bankAccountsLog": "Bank Accounts Log",
        "accountingAccountLog": "Accounting Account Log",
        "accountingAccountsLog": "Accounting Accounts Log",
        "accountingRecordLog": "Accounting Record Log",
        "accountingRecordsLog": "Accounting Records Log",
        "settingBasicLog": "Setting Basic Log",
        "settingsBasicLog": "Settings Basic Log",
        "settingAdvancedLog": "Setting Advanced Log",
        "settingsAdvancedLog": "Settings Advanced Log",
        "clientPaymentLog": "Client Payment Log",
        "clientPaymentsLog": "Client Payments Log",
        "supplierPaymentLog": "Supplier Payment Log",
        "supplierPaymentsLog": "Supplier Payments Log",
        "saleLog": "Sale Log",
        "quotationLog": "Quotation Log",
        "productCategoryLog": "Product Category Log",
        "salesGeneralSettingsLog": "Sales General Settings Log",
        "buysGeneralSettingsLog": "Buys General Settings Log",
        "clientSettingsLog": "Client Settings Log",
        "supplierSettingsLog": "Supplier Settings Log",
        "cashSettingsLog": "Cash Settings Log",
        "accountingSettingsLog": "Accounting Settings Log",
        "importLog": "Ιστορικό Εισαγωγής Αρχείου"
    },
    Countries: {
        GR: "Greece",
        AD: "Andorra",
        AE: "United Arab Emirates",
        AF: "Afghanistan",
        AG: "Antigua and Barbuda",
        AI: "Anguilla",
        AL: "Albania",
        AM: "Armenia",
        AN: "Netherlands Antilles",
        AO: "Angola",
        AQ: "Antarctica",
        AR: "Argentina",
        AS: "American Samoa",
        AT: "Austria",
        AU: "Australia",
        AW: "Aruba",
        AX: "Åland Islands",
        AZ: "Azerbaijan",
        BA: "Bosnia and Herzegovina",
        BB: "Barbados",
        BD: "Bangladesh",
        BE: "Belgium",
        BF: "Burkina Faso",
        BG: "Bulgaria",
        BH: "Bahrain",
        BI: "Burundi",
        BJ: "Benin",
        BL: "Saint Barthélemy",
        BM: "Bermuda",
        BN: "Brunei Darussalam",
        BO: "Bolivia",
        BR: "Brazil",
        BS: "Bahamas",
        BT: "Bhutan",
        BV: "Bouvet Island",
        BW: "Botswana",
        BY: "Belarus",
        BZ: "Belize",
        CA: "Canada",
        CC: "Cocos (Keeling) Islands",
        CD: "Congo, Democratic Republic of the",
        CF: "Central African Republic",
        CG: "Congo",
        CH: "Switzerland",
        CI: "Côte d'Ivoire",
        CK: "Cook Islands",
        CL: "Chile",
        CM: "Cameroon",
        CN: "China",
        CO: "Colombia",
        CR: "Costa Rica",
        CU: "Cuba",
        CV: "Cabo Verde",
        CX: "Christmas Island",
        CY: "Cyprus",
        CZ: "Czechia",
        DE: "Germany",
        DJ: "Djibouti",
        DK: "Denmark",
        DM: "Dominica",
        DO: "Dominican Republic",
        DZ: "Algeria",
        EC: "Ecuador",
        EE: "Estonia",
        EG: "Egypt",
        EH: "Western Sahara",
        ER: "Eritrea",
        ES: "Spain",
        ET: "Ethiopia",
        FI: "Finland",
        FJ: "Fiji",
        FK: "Falkland Islands",
        FM: "Micronesia, Federated States of",
        FO: "Faroe Islands",
        FR: "France",
        GA: "Gabon",
        GB: "United Kingdom",
        GD: "Grenada",
        GE: "Georgia",
        GF: "French Guiana",
        GG: "Guernsey",
        GH: "Ghana",
        GI: "Gibraltar",
        GL: "Greenland",
        GM: "Gambia",
        GN: "Guinea",
        GP: "Guadeloupe",
        GQ: "Equatorial Guinea",
        GS: "South Georgia and the South Sandwich Islands",
        GT: "Guatemala",
        GU: "Guam",
        GW: "Guinea-Bissau",
        GY: "Guyana",
        HK: "Hong Kong",
        HM: "Heard Island and McDonald Islands",
        HN: "Honduras",
        HR: "Croatia",
        HT: "Haiti",
        HU: "Hungary",
        ID: "Indonesia",
        IE: "Ireland",
        IL: "Israel",
        IM: "Isle of Man",
        IN: "India",
        IO: "British Indian Ocean Territory",
        IQ: "Iraq",
        IR: "Iran",
        IS: "Iceland",
        IT: "Italy",
        JE: "Jersey",
        JM: "Jamaica",
        JO: "Jordan",
        JP: "Japan",
        KE: "Kenya",
        KG: "Kyrgyzstan",
        KH: "Cambodia",
        KI: "Kiribati",
        KM: "Comoros",
        KN: "Saint Kitts and Nevis",
        KP: "North Korea (Democratic People's Republic of Korea)",
        KR: "South Korea",
        KW: "Kuwait",
        KY: "Cayman Islands",
        KZ: "Kazakhstan",
        LA: "Laos",
        LB: "Lebanon",
        LC: "Saint Lucia",
        LI: "Liechtenstein",
        LK: "Sri Lanka",
        LR: "Liberia",
        LS: "Lesotho",
        LT: "Lithuania",
        LU: "Luxembourg",
        LV: "Latvia",
        LY: "Libya",
        MA: "Morocco",
        MC: "Monaco",
        MD: "Moldova",
        ME: "Montenegro",
        MF: "Saint Martin (French part)",
        MG: "Madagascar",
        MH: "Marshall Islands",
        MK: "North Macedonia",
        ML: "Mali",
        MM: "Myanmar",
        MN: "Mongolia",
        MO: "Macao",
        MP: "Northern Mariana Islands",
        MQ: "Martinique",
        MR: "Mauritania",
        MS: "Montserrat",
        MT: "Malta",
        MU: "Mauritius",
        MV: "Maldives",
        MW: "Malawi",
        MX: "Mexico",
        MY: "Malaysia",
        MZ: "Mozambique",
        NA: "Namibia",
        NC: "New Caledonia",
        NE: "Niger",
        NF: "Norfolk Island",
        NG: "Nigeria",
        NI: "Nicaragua",
        NL: "Netherlands",
        NO: "Norway",
        NP: "Nepal",
        NR: "Nauru",
        NU: "Niue",
        NZ: "New Zealand",
        OM: "Oman",
        PA: "Panama",
        PE: "Peru",
        PF: "French Polynesia",
        PG: "Papua New Guinea",
        PH: "Philippines",
        PK: "Pakistan",
        PL: "Poland",
        PM: "Saint Pierre and Miquelon",
        PN: "Pitcairn",
        PR: "Puerto Rico",
        PS: "Palestine, State of",
        PT: "Portugal",
        PW: "Palau",
        PY: "Paraguay",
        QA: "Qatar",
        RE: "Réunion",
        RO: "Romania",
        RS: "Serbia",
        RU: "Russian Federation",
        RW: "Rwanda",
        SA: "Saudi Arabia",
        SB: "Solomon Islands",
        SC: "Seychelles",
        SD: "Sudan",
        SE: "Sweden",
        SG: "Singapore",
        SH: "Saint Helena, Ascension and Tristan da Cunha",
        SI: "Slovenia",
        SJ: "Svalbard and Jan Mayen",
        SK: "Slovakia",
        SL: "Sierra Leone",
        SM: "San Marino",
        SN: "Senegal",
        SO: "Somalia",
        SR: "Suriname",
        ST: "Sao Tome and Principe",
        SV: "El Salvador",
        SY: "Syrian Arab Republic",
        SZ: "Eswatini",
        TC: "Turks and Caicos Islands",
        TD: "Chad",
        TF: "French Southern Territories",
        TG: "Togo",
        TH: "Thailand",
        TJ: "Tajikistan",
        TK: "Tokelau",
        TL: "Timor-Leste",
        TM: "Turkmenistan",
        TN: "Tunisia",
        TO: "Tonga",
        TR: "Türkiye",
        TT: "Trinidad and Tobago",
        TV: "Tuvalu",
        TW: "Taiwan",
        TZ: "Tanzania",
        UA: "Ukraine",
        UG: "Uganda",
        UM: "United States Minor Outlying Islands",
        US: "United States",
        UY: "Uruguay",
        UZ: "Uzbekistan",
        VA: "Holy See (Vatican City State)",
        VC: "Saint Vincent and the Grenadines",
        VE: "Venezuela",
        VG: "Virgin Islands (British)",
        VI: "Virgin Islands (U.S.)",
        VN: "Vietnam",
        VU: "Vanuatu",
        WF: "Wallis and Futuna",
        WS: "Samoa",
        YE: "Yemen",
        YT: "Mayotte",
        ZA: "South Africa",
        ZM: "Zambia",
        ZW: "Zimbabwe",
        OC: "Other Country",
    },
}
